package org.gymly.data

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.forms.MultiPartFormDataContent
import io.ktor.client.request.forms.formData
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import io.ktor.http.contentType
import io.ktor.http.isSuccess
import org.gymly.api.ApiException
import org.gymly.api.PortalSession
import org.gymly.api.createGymlyHttpClient
import org.gymly.auth.AuthPersistence
import org.gymly.auth.SessionActivity
import org.gymly.auth.StoredAuthKind
import org.gymly.api.dto.AdminBookingDto
import org.gymly.api.dto.AdminBranchDto
import org.gymly.api.dto.AdminClientDto
import org.gymly.api.dto.UpdateAdminMembershipOrderPaymentDateRequestDto
import org.gymly.api.dto.AdminCompanyDto
import org.gymly.api.dto.PublicCompanyDto
import org.gymly.api.dto.AdminProductCategoryDto
import org.gymly.api.dto.AdminProductDto
import org.gymly.api.dto.UpsertAdminProductCategoryRequestDto
import org.gymly.api.dto.AdminStaffMeDto
import org.gymly.api.dto.AdminStaffMeUpdateDto
import org.gymly.api.dto.AdminStaffLocaleDto
import org.gymly.api.dto.AdminStaffPasswordDto
import org.gymly.api.dto.AdminMembershipOrderDto
import org.gymly.api.dto.AdminStorePaymentLineDto
import org.gymly.api.dto.AdminStoreSaleDto
import org.gymly.api.dto.ApproveAdminStoreSaleRequestDto
import org.gymly.api.dto.ProofValidationRequestDto
import org.gymly.api.dto.ProofValidationResponseDto
import org.gymly.api.dto.UpsertAdminStoreSaleItemDto
import org.gymly.api.dto.UpsertAdminMembershipOrderRequestDto
import org.gymly.api.dto.AdminMembershipOrderPaymentDateDto
import org.gymly.api.dto.RecordAdminMembershipOrderPaymentRequestDto
import org.gymly.api.dto.UpsertAdminStoreSaleRequestDto
import org.gymly.api.dto.AdminSettingsMailDto
import org.gymly.api.dto.AdminSettingsNotificationRuleDto
import org.gymly.api.dto.AdminSettingsNotificationTemplateDto
import org.gymly.api.dto.AdminNotificationTemplateVariablesDto
import org.gymly.api.dto.AdminSettingsPaymentDto
import org.gymly.api.dto.AdminPaymentMethodTypeDto
import org.gymly.api.dto.AdminPaymentMethodsBundleDto
import org.gymly.api.dto.UpsertAdminPaymentMethodTypeRequestDto
import org.gymly.api.dto.CreateAdminPaymentMethodTypeRequestDto
import org.gymly.api.dto.ActivateAdminProductLicenseDto
import org.gymly.api.dto.AdminProductLicenseStatusDto
import org.gymly.api.dto.AdminSettingsModulesDto
import org.gymly.api.dto.UpdateAdminSettingsModulesDto
import org.gymly.api.dto.AdminAccessEventDto
import org.gymly.api.dto.AdminAccessSimulateRequestDto
import org.gymly.api.dto.AdminAccessSyncDto
import org.gymly.api.dto.AdminCaptureFaceDto
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import org.gymly.api.dto.AdminStaffAccessSyncDto
import org.gymly.api.dto.AdminAccessTerminalDto
import org.gymly.api.dto.AdminAccessTestDto
import org.gymly.api.dto.AdminSettingsRoleDto
import org.gymly.api.dto.AiReportResponseDto
import org.gymly.api.dto.AdminApprovalRequestDto
import org.gymly.api.dto.AdminApprovalPendingCountDto
import org.gymly.api.dto.AdminApprovalReviewDto
import org.gymly.api.dto.AdminSettingsUserDto
import org.gymly.api.dto.ReplaceAdminSettingsNotificationRulesRequestDto
import org.gymly.api.dto.UpsertAdminProductRequestDto
import org.gymly.api.dto.UpsertAdminSettingsMailRequestDto
import org.gymly.api.dto.UpsertAdminSettingsNotificationRuleDto
import org.gymly.api.dto.UpsertAdminSettingsNotificationTemplateDto
import org.gymly.api.dto.UpsertAdminSettingsPaymentRequestDto
import org.gymly.api.dto.UpsertAdminAccessTerminalRequestDto
import org.gymly.api.dto.UpsertAdminSettingsRoleRequestDto
import org.gymly.api.dto.UpsertAdminSettingsUserRequestDto
import org.gymly.api.dto.ManualMembershipRequestDto
import org.gymly.api.dto.AdminMembershipAccessHistoryDto
import org.gymly.api.dto.AdminMembershipDto
import org.gymly.api.dto.AdminMembershipPlanDto
import org.gymly.api.dto.AdminCashReconciliationReportDto
import org.gymly.api.dto.AdminEnrollmentReportDto
import org.gymly.api.dto.AdminMembershipReportDto
import org.gymly.api.dto.AdminNotificationItemDto
import org.gymly.api.dto.AdminNotificationListDto
import org.gymly.api.dto.AdminOrderDto
import org.gymly.api.dto.AdminPaymentDto
import org.gymly.api.dto.AdminInventoryReportDto
import org.gymly.api.dto.AdminSalesReportDto
import org.gymly.api.dto.AdminScheduleDto
import org.gymly.api.dto.AdminSearchHitDto
import org.gymly.api.dto.AdminServiceDto
import org.gymly.api.dto.AdminSessionReportDto
import org.gymly.api.dto.AdminStaffAuditEventDto
import org.gymly.api.dto.RecordAdminStaffAuditRequestDto
import org.gymly.api.dto.AdminStaffUserDto
import org.gymly.api.dto.AdminWorkDayScheduleDto
import org.gymly.api.dto.AdminWorkTimeBlockDto
import org.gymly.api.dto.AdminTrainingSessionDto
import org.gymly.api.dto.AdminVisitDto
import org.gymly.api.dto.CreateAdminBookingRequestDto
import org.gymly.api.dto.CreateAdminClientRequestDto
import org.gymly.api.dto.CreateAdminMembershipPlanRequestDto
import org.gymly.api.dto.CreateAdminMembershipRequestDto
import org.gymly.api.dto.CreateAdminOrderLineDto
import org.gymly.api.dto.CreateAdminOrderRequestDto
import org.gymly.api.dto.CreateAdminPaymentRequestDto
import org.gymly.api.dto.CollectAdminDiscountDto
import org.gymly.api.dto.CollectAdminPaymentLineDto
import org.gymly.api.dto.CollectAdminPaymentRequestDto
import org.gymly.api.dto.CollectAdminPaymentResponseDto
import org.gymly.api.dto.CollectAdminPaymentTargetDto
import org.gymly.api.dto.CreateAdminScheduleRequestDto
import org.gymly.api.dto.CreateAdminServiceRequestDto
import org.gymly.api.dto.CreateAdminTrainingSessionRequestDto
import org.gymly.api.dto.CreateAdminVisitRequestDto
import org.gymly.api.dto.CreateAdminWorkerRequestDto
import org.gymly.api.dto.DashboardSummaryDto
import org.gymly.api.dto.MarketingPromotionDto
import org.gymly.api.dto.PublicStatsDto
import org.gymly.api.dto.StaffLoginRequestDto
import org.gymly.api.dto.StaffLoginResponseDto
import org.gymly.api.dto.UpdateAdminBookingRequestDto
import org.gymly.api.dto.UpdateAdminClientRequestDto
import org.gymly.api.dto.UpdateAdminMembershipPlanRequestDto
import org.gymly.api.dto.UpdateAdminMembershipRequestDto
import org.gymly.api.dto.UpdateAdminOrderRequestDto
import org.gymly.api.dto.UpdateAdminPaymentRequestDto
import org.gymly.api.dto.UpdateAdminScheduleRequestDto
import org.gymly.api.dto.UpdateAdminServiceRequestDto
import org.gymly.api.dto.UpdateAdminWorkerRequestDto
import org.gymly.api.dto.UpdateMarketingPromotionRequestDto
import org.gymly.api.dto.UpsertAdminBranchRequestDto
import org.gymly.api.dto.UpsertAdminCompanyRequestDto
import org.gymly.api.dto.UpsertAdminCompanyRepresentativeDto
import org.gymly.api.resolveApiUrl
import org.gymly.model.AdminBillingPeriod
import org.gymly.model.AdminBookingItem
import org.gymly.model.AdminBookingStatus
import org.gymly.model.AdminBookingUpsert
import org.gymly.model.AdminBranch
import org.gymly.model.AdminBranchUpsert
import org.gymly.model.AdminTerminalReconcileAction
import org.gymly.model.AdminTerminalReconcileReport
import org.gymly.model.AdminTerminalReconcileResult
import org.gymly.model.AdminTerminalReconcileItem
import org.gymly.api.dto.TerminalReconcileActionDto
import org.gymly.api.dto.TerminalReconcileApplyRequestDto
import org.gymly.api.dto.TerminalReconcileItemDto
import org.gymly.api.dto.TerminalReconcileReportDto
import org.gymly.api.dto.TerminalReconcileResultDto
import org.gymly.model.AdminCatalogService
import org.gymly.model.AdminCatalogServiceUpsert
import org.gymly.model.AdminClient
import org.gymly.model.AdminPortalActivation
import org.gymly.api.dto.AdminPortalActivationDto
import org.gymly.model.AdminClientStatus
import org.gymly.model.AdminClientUpsert
import org.gymly.model.AdminCompany
import org.gymly.model.AdminCompanyRepresentative
import org.gymly.model.AdminCompanyUpsert
import org.gymly.model.AdminCompanyRepresentativeUpsert
import org.gymly.model.AdminDashboardSummary
import org.gymly.model.AdminKpi
import org.gymly.model.AdminListRow
import org.gymly.model.AdminMembershipAccessMode
import org.gymly.model.AdminMembershipAccessEventType
import org.gymly.model.AdminMembershipAccessHistoryItem
import org.gymly.model.AdminMembershipItem
import org.gymly.model.AdminMembershipOrder
import org.gymly.model.AdminMembershipOrderOrigin
import org.gymly.model.AdminMembershipOrderPayment
import org.gymly.model.AdminMembershipOrderStatus
import org.gymly.model.AdminMembershipOrderUpsert
import org.gymly.model.AdminMe
import org.gymly.model.AdminMeUpsert
import org.gymly.model.AdminMembershipPlanItem
import org.gymly.model.AdminMembershipPlanUpsert
import org.gymly.model.AdminPlanServiceSummary
import org.gymly.model.AdminMembershipStatus
import org.gymly.model.AdminMembershipUpsert
import org.gymly.model.AdminNotificationFeed
import org.gymly.model.AdminNotificationItem
import org.gymly.model.PublicCompanyBranding
import org.gymly.model.PublicMarketingStats
import org.gymly.model.AdminOrder
import org.gymly.model.AdminOrderItem
import org.gymly.model.AdminOrderStatus
import org.gymly.model.AdminOrderUpsert
import org.gymly.model.AdminPayment
import org.gymly.model.AdminPaymentMethod
import org.gymly.model.AdminPaymentOrigin
import org.gymly.model.AdminPaymentStatus
import org.gymly.model.AdminPaymentCollect
import org.gymly.model.AdminPaymentDiscount
import org.gymly.model.AdminPaymentUpsert
import org.gymly.model.AdminPersonSex
import org.gymly.model.AdminPromotion
import org.gymly.model.AdminPromotionSlide
import org.gymly.model.AdminPromotionUpsert
import org.gymly.model.AdminReportExportFormat
import org.gymly.model.AdminReportFile
import org.gymly.model.AdminReportFilters
import org.gymly.model.AdminReportKind
import org.gymly.model.AdminRoute
import org.gymly.model.AdminScheduleSlot
import org.gymly.model.AdminScheduleType
import org.gymly.model.AdminScheduleUpsert
import org.gymly.model.AdminVisitItem
import org.gymly.model.AdminVisitUpsert
import org.gymly.model.AdminSearchHit
import org.gymly.model.AdminEnrollmentReport
import org.gymly.model.AdminEnrollmentReportRow
import org.gymly.model.AdminInventoryReport
import org.gymly.model.AdminInventoryReportRow
import org.gymly.model.AdminMembershipReport
import org.gymly.model.AdminMembershipReportRow
import org.gymly.model.AdminCashMethodAmount
import org.gymly.model.AdminCashReconciliationReport
import org.gymly.model.AdminCashReconciliationRow
import org.gymly.model.AdminSalesReport
import org.gymly.model.AdminSalesReportRow
import org.gymly.util.todayIsoDate
import org.gymly.model.AdminSessionReport
import org.gymly.model.AdminSessionReportRow
import org.gymly.model.AdminStaffAuditEvent
import org.gymly.model.AdminStaffAuditEventType
import org.gymly.model.AdminStaffAuditRecord
import org.gymly.model.AdminServiceType
import org.gymly.model.AdminProduct
import org.gymly.model.AdminProductCategoryItem
import org.gymly.model.AdminProductStockLevel
import org.gymly.model.AdminProductUpsert
import org.gymly.model.AdminStoreSale
import org.gymly.model.AdminStorePaymentLine
import org.gymly.model.AdminStoreSaleInvoiceFile
import org.gymly.model.AdminPaymentReceiptFile
import org.gymly.model.AdminStoreSaleItem
import org.gymly.model.AdminStoreSaleMethod
import org.gymly.model.AdminStoreSaleOrigin
import org.gymly.model.AdminStoreSaleStatus
import org.gymly.model.AdminStoreSaleUpsert
import org.gymly.model.AdminSettingsMail
import org.gymly.model.AdminSettingsMailUpsert
import org.gymly.model.AdminSettingsNotificationRule
import org.gymly.model.AdminSettingsNotificationRuleUpsert
import org.gymly.model.AdminSettingsNotificationTemplate
import org.gymly.model.AdminSettingsNotificationTemplateUpsert
import org.gymly.model.AdminSettingsPayment
import org.gymly.model.AdminSettingsPaymentUpsert
import org.gymly.model.AdminPaymentMethodType
import org.gymly.model.AdminPaymentMethodTypeCreate
import org.gymly.model.AdminPaymentMethodTypeUpsert
import org.gymly.model.AdminProductLicenseStatus
import org.gymly.model.AdminSettingsModules
import org.gymly.model.AdminSettingsModulesUpsert
import org.gymly.model.AdminPaymentMethodProviderConfig
import org.gymly.model.AdminPaymentMethodsBundle
import org.gymly.model.AdminAccessAttendanceMode
import org.gymly.model.AdminAccessEvent
import org.gymly.model.AdminAccessSyncResult
import org.gymly.model.AdminAccessTerminal
import org.gymly.model.AdminAccessTerminalUpsert
import org.gymly.model.AdminAccessTestResult
import org.gymly.model.AdminSettingsPermissionModule
import org.gymly.model.AdminApprovalRequest
import org.gymly.model.AdminSettingsRole
import org.gymly.model.AdminSettingsRoleUpsert
import org.gymly.model.AdminSettingsUser
import org.gymly.model.AdminSettingsUserStatus
import org.gymly.model.AdminSettingsUserType
import org.gymly.model.AdminSettingsUserUpsert
import org.gymly.model.AdminNotificationEventCode
import org.gymly.model.AdminPaypalMode
import org.gymly.model.AdminSmtpSecurityMode
import org.gymly.model.AdminStaffRole
import org.gymly.model.AdminTrainer
import org.gymly.model.AdminTrainingAttendance
import org.gymly.model.AdminUser
import org.gymly.model.AdminWorker
import org.gymly.model.AdminWorkerUpsert
import org.gymly.model.AdminWorkDaySchedule
import org.gymly.model.AdminWorkTimeBlock
import org.gymly.model.PickedImagePayload
import org.gymly.util.formatMoney
import org.gymly.util.formatTime
import org.gymly.util.parseContentDispositionFileName

class HttpAdminRepository(
    private val session: PortalSession,
    val client: HttpClient = createGymlyHttpClient(session),
) : AdminRepository {

    private fun url(path: String): String = resolveApiUrl(session, path)

    private suspend inline fun <reified T> get(path: String): T {
        val response = client.get(url(path))
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body()
    }

    private suspend inline fun <reified T> post(path: String, body: Any): T {
        val response = client.post(url(path)) {
            contentType(ContentType.Application.Json)
            setBody(body)
        }
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body()
    }

    private suspend inline fun <reified T> put(path: String, body: Any): T {
        val response = client.put(url(path)) {
            contentType(ContentType.Application.Json)
            setBody(body)
        }
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body()
    }

    private suspend fun deleteNoContent(path: String) {
        val response = client.delete(url(path))
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
    }

    private suspend fun throwIfPendingApproval(response: io.ktor.client.statement.HttpResponse) {
        if (response.status != io.ktor.http.HttpStatusCode.Accepted) return
        val pending = response.body<org.gymly.api.dto.AdminPendingApprovalDto>()
        throw org.gymly.model.AdminPendingApprovalException(
            pending.approvalId,
            pending.message?.takeIf { it.isNotBlank() }
                ?: "Necesitas aprobación. Se avisó a quienes pueden autorizar.",
        )
    }

    private suspend fun patchNoContent(path: String, body: Any) {
        val response = client.patch(url(path)) {
            contentType(ContentType.Application.Json)
            setBody(body)
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
    }

    private fun AdminStaffMeDto.toMe(): AdminMe = AdminMe(
        id = id,
        displayName = displayName,
        email = email,
        role = role,
        roleLabel = roleLabel ?: role,
        active = active,
        photoUrl = photoUrl?.let { resolveApiUrl(session, it) },
        preferredLocale = preferredLocale,
        branchId = branchId,
        branchName = branchName,
        membershipOverride = membershipOverride,
        phone = phone,
        docId = docId,
        address = address,
        sex = AdminPersonSex.fromApi(sex),
        createdAt = createdAt,
        permissions = permissions.mapNotNull { AdminSettingsPermissionModule.fromApi(it) }.toSet(),
        workSchedule = workSchedule.map { day ->
            AdminWorkDaySchedule(
                weekday = day.weekday,
                blocks = day.blocks.map { b ->
                    AdminWorkTimeBlock(startTime = b.startTime, endTime = b.endTime)
                },
            )
        },
    )

    private fun AdminClientDto.toModel(): AdminClient = AdminClient(
        id = id,
        personId = personId,
        firstName = firstName,
        lastName = lastName,
        email = email,
        phone = phone,
        docId = docId,
        sex = AdminPersonSex.fromApi(sex),
        address = address,
        status = AdminClientStatus.fromApi(status),
        notes = notes,
        photoUrl = photoUrl?.let { resolveApiUrl(session, it) },
        portalEnabled = portalEnabled,
        branchId = branchId,
        branchName = branchName,
        createdAt = createdAt,
        accessSyncedAt = accessSyncedAt,
        accessSyncError = accessSyncError,
        membershipPlanName = membershipPlanName,
        accessChannels = accessChannels,
        inactivationReason = inactivationReason,
        inactivationNote = inactivationNote,
    )

    private fun AdminStaffUserDto.toWorker(): AdminWorker = AdminWorker(
        id = id,
        displayName = displayName,
        email = email,
        phone = phone,
        docId = docId,
        role = AdminStaffRole.fromApi(role),
        active = active,
        branchId = branchId,
        branchName = branchName,
        createdAt = createdAt,
        sex = AdminPersonSex.fromApi(sex),
        address = address,
        photoUrl = photoUrl?.let { resolveApiUrl(session, it) },
        workSchedule = workSchedule.map { day ->
            AdminWorkDaySchedule(
                weekday = day.weekday,
                blocks = day.blocks.map { b ->
                    AdminWorkTimeBlock(startTime = b.startTime, endTime = b.endTime)
                },
            )
        },
        serviceIds = serviceIds,
        inactivationReason = inactivationReason,
        inactivationNote = inactivationNote,
    )

    private fun AdminServiceDto.toCatalog(): AdminCatalogService = AdminCatalogService(
        id = id,
        name = name,
        type = AdminServiceType.fromApi(type),
        durationMin = durationMin,
        priceCents = priceCents,
        active = active,
        createdAt = createdAt,
        description = description,
        imageUrl = imageUrl?.let { resolveApiUrl(session, it) },
    )

    private fun AdminMembershipPlanDto.toPlan(): AdminMembershipPlanItem = AdminMembershipPlanItem(
        id = id,
        name = name,
        billingPeriod = AdminBillingPeriod.fromApi(billingPeriod),
        scheduleType = AdminScheduleType.fromApi(scheduleType),
        priceCents = priceCents,
        priceUsdCents = priceUsdCents,
        active = active,
        services = services.map {
            AdminPlanServiceSummary(
                id = it.id,
                name = it.name,
                type = AdminServiceType.fromApi(it.type),
            )
        },
        createdAt = createdAt,
        reminderLeadDays = reminderLeadDays,
        effectiveReminderLeadDays = effectiveReminderLeadDays,
    )

    private fun AdminMembershipDto.toMembership(): AdminMembershipItem = AdminMembershipItem(
        id = id,
        clientId = clientId,
        clientName = clientName?.takeIf { it.isNotBlank() } ?: clientId.take(8),
        planId = planId,
        planName = planName,
        status = AdminMembershipStatus.fromApi(status),
        startsAt = startsAt,
        endsAt = endsAt,
        branchId = branchId,
        branchName = branchName,
        trainerId = trainerId,
        trainerName = trainerName,
        accessMode = accessMode?.let { AdminMembershipAccessMode.fromApi(it) }
            ?: AdminMembershipAccessMode.AUTO,
        manualReason = manualReason,
        manualByStaffName = manualByStaffName,
        createdAt = createdAt,
    )

    private fun AdminMembershipAccessHistoryDto.toHistoryItem(): AdminMembershipAccessHistoryItem =
        AdminMembershipAccessHistoryItem(
            id = id,
            eventType = AdminMembershipAccessEventType.fromApi(eventType),
            eventLabel = eventLabel,
            planName = planName,
            trainerName = trainerName,
            status = AdminMembershipStatus.fromApi(status),
            startsAt = startsAt,
            endsAt = endsAt,
            accessMode = accessMode?.let { AdminMembershipAccessMode.fromApi(it) },
            reason = reason,
            staffName = staffName,
            orderNumber = orderNumber,
            amountCents = amountCents,
            occurredAt = occurredAt,
        )

    private fun AdminOrderDto.toOrder(): AdminOrder = AdminOrder(
        id = id,
        orderNumber = orderNumber,
        clientId = clientId,
        clientName = clientName?.takeIf { it.isNotBlank() } ?: clientId.take(8),
        status = AdminOrderStatus.fromApi(status),
        totalAmountCents = totalAmountCents,
        createdAt = createdAt,
        lines = lines.map { line ->
            AdminOrderItem(
                id = line.id,
                serviceId = line.serviceId,
                serviceName = line.serviceName,
                description = line.description,
                qty = line.qty,
                unitPriceCents = line.unitPriceCents,
            )
        },
    )

    private fun AdminPaymentDto.toPayment(): AdminPayment = AdminPayment(
        id = id,
        orderId = orderId,
        clientId = clientId,
        clientName = clientName?.takeIf { it.isNotBlank() } ?: clientId.take(8),
        amountCents = amountCents,
        currency = currency,
        method = AdminPaymentMethod.fromApi(method),
        status = AdminPaymentStatus.fromApi(status),
        origin = AdminPaymentOrigin.fromApi(origin),
        notes = notes,
        payerPhone = payerPhone,
        proofUrl = proofUrl?.let { resolveApiUrl(session, it) },
        proofContentType = proofContentType,
        paidAt = paidAt,
        createdAt = createdAt,
        foreignUsdCents = foreignUsdCents,
        foreignEurCents = foreignEurCents,
        exchangeEffectiveDate = exchangeEffectiveDate,
    )

    private fun MarketingPromotionDto.toPromotion(): AdminPromotion = AdminPromotion(
        id = id,
        title = title,
        details = details,
        displayType = displayType,
        channel = org.gymly.model.AdminMarketingChannel.fromApi(channel),
        active = active,
        sortOrder = sortOrder,
        startsAt = startsAt,
        endsAt = endsAt,
        scheduledAt = scheduledAt,
        whatsappSendStatus = whatsappSendStatus,
        whatsappSentAt = whatsappSentAt,
        whatsappError = whatsappError,
        createdAt = createdAt,
        videoUrl = videoUrl,
        pendingApproval = pendingApproval,
        slides = slides.map { s ->
            AdminPromotionSlide(
                id = s.id,
                sortIndex = s.sortIndex,
                fullUrl = resolveApiUrl(session, s.fullUrl),
                thumbUrl = resolveApiUrl(session, s.thumbUrl),
            )
        },
    )

    /** Inicio del día elegido en Caracas (UTC-4, sin horario de verano). */
    private fun dateToInstant(date: String?): String? {
        val d = date?.trim().orEmpty()
        if (d.isEmpty()) return null
        return if (d.contains("T")) d else "${d.take(10)}T00:00:00-04:00"
    }

    /**
     * Fin del día elegido en Caracas: la fecha de fin es inclusiva. Con medianoche UTC la promoción se
     * ocultaba en el portal la noche del último día.
     */
    private fun endDateToInstant(date: String?): String? {
        val d = date?.trim().orEmpty()
        if (d.isEmpty()) return null
        return if (d.contains("T")) d else "${d.take(10)}T23:59:59-04:00"
    }

    override suspend fun fetchClientTermsMonitoring(): org.gymly.model.AdminClientTermsMonitoring =
        get<org.gymly.api.dto.ClientTermsMonitoringDto>("/api/terms-monitoring/clients").toMonitoringModel()

    override suspend fun resumeTermsNoticeChannel(channel: String): org.gymly.model.AdminClientTermsMonitoring {
        val response = client.post(url("/api/terms-monitoring/clients/notices/channels/$channel/resume")) {}
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<org.gymly.api.dto.ClientTermsMonitoringDto>().toMonitoringModel()
    }

    private fun org.gymly.api.dto.ClientTermsMonitoringDto.toMonitoringModel() = org.gymly.model.AdminClientTermsMonitoring(
        currentVersion = currentVersion,
        available = available,
        canOperate = canOperate,
        canApprove = canApprove,
        channels = org.gymly.model.AdminTermsNoticeChannels(
            email = channels.email,
            whatsapp = channels.whatsapp,
            cooldownDays = channels.cooldownDays,
            emailPaused = channels.emailPaused,
            whatsappPaused = channels.whatsappPaused,
        ),
        members = members.map { it.toModel() },
    )

    override suspend fun applyClientTermsAction(
        clientId: String,
        op: String,
        motivo: String?,
    ): org.gymly.model.AdminClientTermsRow {
        val response = client.post(url("/api/terms-monitoring/clients/$clientId/actions")) {
            contentType(ContentType.Application.Json)
            setBody(org.gymly.api.dto.ClientTermsActionRequestDto(op = op, motivo = motivo))
        }
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<org.gymly.api.dto.ClientTermsRowDto>().toModel()
    }

    private fun org.gymly.api.dto.ClientTermsRowDto.toModel() = org.gymly.model.AdminClientTermsRow(
        id = id,
        name = name,
        email = email,
        portalAccess = portalAccess,
        phone = phone,
        active = active,
        status = status,
        termsVersion = termsVersion,
        termsAcceptedAt = termsAcceptedAt,
        declinedVersion = declinedVersion,
        declinedAt = declinedAt,
        suspensionReason = suspensionReason,
        suspensionNote = suspensionNote,
        suspendedAt = suspendedAt,
    )

    override suspend fun sendClientTermsNotices(
        scope: String,
        clientIds: List<String>?,
        channels: List<String>,
    ): org.gymly.model.AdminTermsNoticeResult {
        val response = client.post(url("/api/terms-monitoring/clients/notices")) {
            contentType(ContentType.Application.Json)
            setBody(org.gymly.api.dto.TermsNoticeRequestDto(
                scope = scope,
                clientIds = clientIds,
                channels = channels.joinToString(","),
            ))
        }
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<org.gymly.api.dto.TermsNoticeResponseDto>().let {
            org.gymly.model.AdminTermsNoticeResult(
                batchId = it.batchId,
                queued = it.queued,
                noContact = it.noContact,
                withinCooldown = it.withinCooldown,
                alreadyQueued = it.alreadyQueued,
            )
        }
    }

    override suspend fun termsNoticeProgress(batchId: String): org.gymly.model.AdminTermsNoticeProgress =
        get<org.gymly.api.dto.TermsNoticeProgressDto>("/api/terms-monitoring/clients/notices/$batchId").let {
            org.gymly.model.AdminTermsNoticeProgress(
                batchId = it.batchId,
                total = it.total,
                sent = it.sent,
                failed = it.failed,
                pending = it.pending,
            )
        }

    override suspend fun passwordRecoveryAvailable(): Boolean =
        get<org.gymly.api.dto.PasswordRecoveryStatusDto>("/api/auth/password-recovery/status").available

    override suspend fun requestPasswordRecovery(scope: String, email: String) {
        post<org.gymly.api.dto.PasswordRecoveryMessageDto>(
            "/api/auth/password-recovery/request",
            org.gymly.api.dto.PasswordRecoveryRequestDto(scope = scope, email = email.trim()),
        )
    }

    override suspend fun confirmPasswordRecovery(
        scope: String,
        email: String,
        code: String,
        newPassword: String,
    ): String = post<org.gymly.api.dto.PasswordRecoveryMessageDto>(
        "/api/auth/password-recovery/confirm",
        org.gymly.api.dto.PasswordRecoveryConfirmDto(
            scope = scope,
            email = email.trim(),
            code = code.trim(),
            newPassword = newPassword,
        ),
    ).message

    override suspend fun login(email: String, password: String): AdminUser {
        if (email.isBlank() || password.isBlank()) {
            error("Completa correo y contraseña.")
        }
        session.accessToken = null
        val res: StaffLoginResponseDto = post(
            "/api/auth/login",
            StaffLoginRequestDto(email = email.trim(), password = password),
        )
        session.accessToken = res.accessToken
        AuthPersistence.save(StoredAuthKind.ADMIN, res.accessToken)
        SessionActivity.markSessionStarted()
        return AdminUser(
            id = res.user.id,
            displayName = res.user.displayName,
            email = res.user.email,
            role = res.user.role,
            preferredLocale = res.user.preferredLocale,
            membershipOverride = res.user.membershipOverride,
            permissionsKnown = false,
        )
    }

    override suspend fun publicStats(): PublicMarketingStats {
        val s = get<PublicStatsDto>("/api/public/stats")
        return PublicMarketingStats(
            activeClients = s.activeClients,
            trainers = s.trainers,
            onTimePaymentPercent = s.onTimePaymentPercent,
        )
    }

    override suspend fun publicCompany(): PublicCompanyBranding {
        val c = get<PublicCompanyDto>("/api/public/company")
        return PublicCompanyBranding(
            id = c.id,
            name = c.name,
            hasLogo = c.hasLogo,
            logoUrl = c.logoUrl?.let { resolveApiUrl(session, it) },
            hasBanner = c.hasBanner,
            bannerUrl = c.bannerUrl?.let { resolveApiUrl(session, it) },
            brandColor = c.brandColor,
            loginShowClients = c.loginShowClients,
            loginShowTrainers = c.loginShowTrainers,
            loginShowOnTime = c.loginShowOnTime,
        )
    }

    override suspend fun fetchMe(): AdminMe =
        get<AdminStaffMeDto>("/api/staff/me").toMe()

    override suspend fun refreshSession(): String {
        val res: StaffLoginResponseDto = client.post(url("/api/auth/refresh")).body()
        return res.accessToken
    }

    override suspend fun updateMe(input: AdminMeUpsert): AdminMe =
        put<AdminStaffMeDto>(
            "/api/staff/me",
            AdminStaffMeUpdateDto(
                displayName = input.displayName.trim(),
                email = input.email?.trim()?.takeIf { it.isNotEmpty() },
                preferredLocale = input.preferredLocale?.trim()?.takeIf { it.isNotEmpty() },
                sex = input.sex?.name ?: throw IllegalArgumentException("El sexo es obligatorio"),
                address = input.address?.trim().orEmpty(),
                phone = input.phone?.trim()?.takeIf { it.isNotEmpty() },
                docId = input.docId?.trim()?.takeIf { it.isNotEmpty() },
            ),
        ).toMe()

    override suspend fun updateMyLocale(preferredLocale: String): AdminMe {
        val response = client.patch(url("/api/staff/me/locale")) {
            contentType(ContentType.Application.Json)
            setBody(AdminStaffLocaleDto(preferredLocale = preferredLocale.trim()))
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminStaffMeDto>().toMe()
    }

    override suspend fun uploadMyPhoto(image: PickedImagePayload): AdminMe {
        val response = client.post(url("/api/staff/me/photo")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminStaffMeDto>().toMe()
    }

    override suspend fun fetchMyPhotoBytes(): ByteArray? {
        val response = client.get(url("/api/staff/me/photo"))
        if (response.status.value == 404) return null
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val bytes = response.body<ByteArray>()
        return bytes.takeIf { it.isNotEmpty() }
    }

    override suspend fun fetchPromotionImageBytes(fullUrl: String): ByteArray? {
        val response = client.get(fullUrl)
        if (response.status.value == 404) return null
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<ByteArray>().takeIf { it.isNotEmpty() }
    }

    override suspend fun deleteMyPhoto() = deleteNoContent("/api/staff/me/photo")

    override suspend fun changeMyPassword(currentPassword: String, newPassword: String) {
        patchNoContent(
            "/api/staff/me/password",
            AdminStaffPasswordDto(currentPassword = currentPassword, newPassword = newPassword),
        )
    }

    override suspend fun dashboardSummary(): AdminDashboardSummary {
        val s = get<DashboardSummaryDto>("/api/dashboard/summary")
        return AdminDashboardSummary(
            activeClients = s.activeClients,
            trainers = s.trainers,
            onTimePaymentPercent = s.onTimePaymentPercent,
            scheduleSlots = s.scheduleSlots,
            bookingsToday = s.bookingsToday,
            bookingsThisWeek = s.bookingsThisWeek,
        )
    }

    override suspend fun dashboardKpis(): List<AdminKpi> {
        val s = dashboardSummary()
        return listOf(
            AdminKpi("Clientes activos", s.activeClients.toString()),
            AdminKpi("Entrenadores", s.trainers.toString()),
            AdminKpi(
                "Pagos a tiempo",
                "${s.onTimePaymentPercent}%",
                "Proxy PAID / (PAID + PENDING)",
            ),
            AdminKpi("Franjas", s.scheduleSlots.toString()),
            AdminKpi("Reservas hoy", s.bookingsToday.toString()),
            AdminKpi("Reservas (7 días)", s.bookingsThisWeek.toString()),
        )
    }

    override suspend fun listTrainers(): List<AdminTrainer> =
        get<List<AdminStaffUserDto>>("/api/users?role=TRAINER")
            .filter { it.active }
            .map {
                AdminTrainer(it.id, it.displayName, it.email, it.role)
            }

    override suspend fun listSchedules(weekStart: String?): List<AdminScheduleSlot> {
        val path = if (weekStart.isNullOrBlank()) "/api/schedules"
        else "/api/schedules?weekStart=${weekStart.take(10)}"
        return get<List<AdminScheduleDto>>(path).map { it.toSchedule() }
    }

    override suspend fun getSchedule(id: String): AdminScheduleSlot =
        get<AdminScheduleDto>("/api/schedules/$id").toSchedule()

    override suspend fun createSchedule(input: AdminScheduleUpsert): AdminScheduleSlot =
        post<AdminScheduleDto>(
            "/api/schedules",
            CreateAdminScheduleRequestDto(
                weekday = input.weekday,
                startTime = normalizeTime(input.startTime),
                endTime = normalizeTime(input.endTime),
                title = input.title.trim(),
                capacity = input.capacity,
                kind = input.kind.name,
                trainerId = input.trainerId,
                serviceId = input.serviceId,
                weekStart = input.weekStart?.take(10),
            ),
        ).toSchedule()

    override suspend fun updateSchedule(id: String, input: AdminScheduleUpsert): AdminScheduleSlot =
        put<AdminScheduleDto>(
            "/api/schedules/$id",
            UpdateAdminScheduleRequestDto(
                weekday = input.weekday,
                startTime = normalizeTime(input.startTime),
                endTime = normalizeTime(input.endTime),
                title = input.title.trim(),
                capacity = input.capacity,
                kind = input.kind.name,
                trainerId = input.trainerId,
                serviceId = input.serviceId,
                weekStart = input.weekStart?.take(10),
            ),
        ).toSchedule()

    override suspend fun deleteSchedule(id: String) {
        deleteNoContent("/api/schedules/$id")
    }

    override suspend fun setScheduleTrainerAbsent(id: String, absent: Boolean): AdminScheduleSlot =
        post<AdminScheduleDto>(
            "/api/schedules/$id/trainer-absent",
            org.gymly.api.dto.SetTrainerAbsentRequestDto(absent = absent),
        ).toSchedule()

    override suspend fun duplicateScheduleWeek(
        sourceWeekStart: String,
        targetWeekStart: String,
        replaceExisting: Boolean,
    ): Int =
        post<org.gymly.api.dto.DuplicateScheduleWeekResponseDto>(
            "/api/schedules/duplicate-week",
            org.gymly.api.dto.DuplicateScheduleWeekRequestDto(
                sourceWeekStart = sourceWeekStart.take(10),
                targetWeekStart = targetWeekStart.take(10),
                replaceExisting = replaceExisting,
            ),
        ).copied

    override suspend fun listBookings(from: String?, to: String?): List<AdminBookingItem> {
        val qs = buildString {
            if (from != null || to != null) {
                append("?")
                val parts = mutableListOf<String>()
                from?.let { parts += "from=$it" }
                to?.let { parts += "to=$it" }
                append(parts.joinToString("&"))
            }
        }
        return get<List<AdminBookingDto>>("/api/bookings$qs").map { it.toBooking() }
    }

    override suspend fun getBooking(id: String): AdminBookingItem =
        get<AdminBookingDto>("/api/bookings/$id").toBooking()

    override suspend fun createBooking(input: AdminBookingUpsert): AdminBookingItem =
        post<AdminBookingDto>(
            "/api/bookings",
            CreateAdminBookingRequestDto(
                clientId = input.clientId,
                scheduleId = input.scheduleId,
                sessionDate = input.sessionDate,
                notes = input.notes,
            ),
        ).toBooking()

    override suspend fun updateBooking(id: String, input: AdminBookingUpsert): AdminBookingItem =
        put<AdminBookingDto>(
            "/api/bookings/$id",
            UpdateAdminBookingRequestDto(
                clientId = input.clientId,
                scheduleId = input.scheduleId,
                sessionDate = input.sessionDate,
                notes = input.notes,
            ),
        ).toBooking()

    override suspend fun markBookingAttended(id: String): AdminBookingItem =
        post<AdminBookingDto>("/api/bookings/$id/attend", emptyMap<String, String>()).toBooking()

    override suspend fun markBookingNoShow(id: String): AdminBookingItem =
        post<AdminBookingDto>("/api/bookings/$id/no-show", emptyMap<String, String>()).toBooking()

    override suspend fun deleteBooking(id: String) {
        deleteNoContent("/api/bookings/$id")
    }

    override suspend fun listVisits(from: String?, to: String?): List<AdminVisitItem> {
        val qs = buildString {
            if (from != null || to != null) {
                append("?")
                val parts = mutableListOf<String>()
                from?.let { parts += "from=$it" }
                to?.let { parts += "to=$it" }
                append(parts.joinToString("&"))
            }
        }
        return get<List<AdminVisitDto>>("/api/visits$qs").map { it.toVisit() }
    }

    override suspend fun createVisit(input: AdminVisitUpsert): AdminVisitItem =
        post<AdminVisitDto>(
            "/api/visits",
            CreateAdminVisitRequestDto(
                clientId = input.clientId,
                staffId = input.staffId,
                scheduleId = input.scheduleId,
                trainerId = input.trainerId,
                occurredAt = input.occurredAt,
                notes = input.notes,
            ),
        ).toVisit()

    override suspend fun deleteVisit(id: String) {
        deleteNoContent("/api/visits/$id")
    }

    override suspend fun search(
        query: String,
        trainerId: String?,
        planId: String?,
    ): List<AdminSearchHit> {
        val q = query.trim()
        val hasText = q.length >= 2
        val hasFilter = !trainerId.isNullOrBlank() || !planId.isNullOrBlank()
        if (!hasText && !hasFilter) return emptyList()
        val params = buildString {
            append("q=${q.encodeURLQuery()}")
            if (!trainerId.isNullOrBlank()) append("&trainerId=${trainerId.encodeURLQuery()}")
            if (!planId.isNullOrBlank()) append("&planId=${planId.encodeURLQuery()}")
        }
        return get<List<AdminSearchHitDto>>("/api/search?$params").map {
            AdminSearchHit(it.id, it.type, it.title, it.subtitle)
        }
    }

    override suspend fun notifications(): AdminNotificationFeed {
        val n = get<AdminNotificationListDto>("/api/notifications")
        return AdminNotificationFeed(
            unreadCount = n.unreadCount,
            items = n.items.map { it.toModel() },
        )
    }

    override suspend fun markNotificationRead(id: String): AdminNotificationItem {
        val response = client.post(url("/api/notifications/$id/read"))
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminNotificationItemDto>().toModel()
    }

    override suspend fun markAllNotificationsRead(): AdminNotificationFeed {
        val response = client.post(url("/api/notifications/read-all"))
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val n = response.body<AdminNotificationListDto>()
        return AdminNotificationFeed(
            unreadCount = n.unreadCount,
            items = n.items.map { it.toModel() },
        )
    }

    override suspend fun listClients(): List<AdminClient> =
        get<List<AdminClientDto>>("/api/clients").map { it.toModel() }

    override suspend fun getClient(id: String): AdminClient =
        get<AdminClientDto>("/api/clients/$id").toModel()

    override suspend fun createClient(input: AdminClientUpsert): AdminClient =
        post<AdminClientDto>(
            "/api/clients",
            CreateAdminClientRequestDto(
                firstName = input.firstName,
                lastName = input.lastName,
                email = input.email,
                phone = input.phone,
                docId = input.docId,
                sex = input.sex?.name,
                address = input.address.trim().takeIf { it.isNotEmpty() },
                status = input.status.name,
                notes = input.notes,
                portalPassword = input.portalPassword,
                branchId = input.branchId,
            ),
        ).toModel()

    override suspend fun updateClient(id: String, input: AdminClientUpsert): AdminClient =
        put<AdminClientDto>(
            "/api/clients/$id",
            UpdateAdminClientRequestDto(
                firstName = input.firstName,
                lastName = input.lastName,
                email = input.email,
                phone = input.phone,
                docId = input.docId,
                sex = input.sex?.name,
                address = input.address,
                status = input.status.name,
                notes = input.notes,
                portalPassword = input.portalPassword,
                branchId = input.branchId,
                disablePortal = input.disablePortal.takeIf { it },
                inactivationReason = input.inactivationReason,
                inactivationNote = input.inactivationNote,
            ),
        ).toModel()

    override suspend fun deleteClient(id: String) {
        deleteNoContent("/api/clients/$id")
    }

    override suspend fun uploadClientPhoto(id: String, image: PickedImagePayload): AdminClient {
        val response = client.post(url("/api/clients/$id/photo")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminClientDto>().toModel()
    }

    override suspend fun fetchClientPhotoBytes(id: String): ByteArray? {
        val response = client.get(url("/api/clients/$id/photo"))
        if (response.status.value == 404) return null
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val bytes = response.body<ByteArray>()
        return bytes.takeIf { it.isNotEmpty() }
    }

    override suspend fun deleteClientPhoto(id: String) = deleteNoContent("/api/clients/$id/photo")

    override suspend fun activateClientPortal(clientId: String): AdminPortalActivation {
        val dto = post<AdminPortalActivationDto>(
            "/api/clients/$clientId/portal-access",
            emptyMap<String, String>(),
        )
        return AdminPortalActivation(
            sent = dto.sent,
            temporaryPassword = dto.temporaryPassword,
            message = dto.message,
        )
    }

    override suspend fun listBranches(): List<AdminBranch> =
        get<List<AdminBranchDto>>("/api/branches").map { it.toBranch(session) }

    override suspend fun reconcileTerminal(terminalId: String): AdminTerminalReconcileReport =
        get<TerminalReconcileReportDto>("/api/access/terminals/$terminalId/reconcile").let { dto ->
            fun TerminalReconcileItemDto.toItem() = AdminTerminalReconcileItem(
                employeeNo = employeeNo,
                name = name,
                kind = kind,
                reason = reason,
                action = action,
            )
            AdminTerminalReconcileReport(
                terminalId = dto.terminalId,
                terminalName = dto.terminalName,
                reviewedAt = dto.reviewedAt,
                onTerminal = dto.onTerminal,
                expected = dto.expected,
                sobran = dto.sobran.map { it.toItem() },
                faltan = dto.faltan.map { it.toItem() },
            )
        }

    override suspend fun applyTerminalReconcile(
        terminalId: String,
        actions: List<AdminTerminalReconcileAction>,
    ): AdminTerminalReconcileResult =
        post<TerminalReconcileResultDto>(
            "/api/access/terminals/$terminalId/reconcile/apply",
            TerminalReconcileApplyRequestDto(
                items = actions.map { TerminalReconcileActionDto(employeeNo = it.employeeNo, action = it.action) },
            ),
        ).let { AdminTerminalReconcileResult(applied = it.applied, errors = it.errors) }

    override suspend fun getBranch(id: String): AdminBranch =
        get<AdminBranchDto>("/api/branches/$id").toBranch(session)

    override suspend fun createBranch(input: AdminBranchUpsert): AdminBranch {
        val created = post<AdminBranchDto>(
            "/api/branches",
            UpsertAdminBranchRequestDto(
                name = input.name.trim(),
                address = input.address?.trim()?.ifBlank { null },
                ownerName = input.ownerName?.trim()?.ifBlank { null },
                ownerId = input.ownerId,
            ),
        ).toBranch(session)
        return uploadBranchMedia(created.id, input.logo, input.banner) ?: created
    }

    override suspend fun updateBranch(id: String, input: AdminBranchUpsert): AdminBranch {
        val updated = put<AdminBranchDto>(
            "/api/branches/$id",
            UpsertAdminBranchRequestDto(
                name = input.name.trim(),
                address = input.address?.trim()?.ifBlank { null },
                ownerName = input.ownerName?.trim()?.ifBlank { null },
                ownerId = input.ownerId,
            ),
        ).toBranch(session)
        return uploadBranchMedia(id, input.logo, input.banner) ?: updated
    }

    override suspend fun deleteBranch(id: String) {
        deleteNoContent("/api/branches/$id")
    }

    override suspend fun getCompany(): AdminCompany =
        get<AdminCompanyDto>("/api/company").toCompany(session)

    override suspend fun updateCompany(input: AdminCompanyUpsert): AdminCompany {
        val updated = put<AdminCompanyDto>(
            "/api/company",
            UpsertAdminCompanyRequestDto(
                name = input.name.trim(),
                address = input.address?.trim()?.takeIf { it.isNotEmpty() },
                taxId = input.taxId?.trim()?.takeIf { it.isNotEmpty() },
                brandColor = input.brandColor?.trim()?.takeIf { it.isNotEmpty() },
                timezone = input.timezone.trim().ifBlank { "America/Caracas" },
                loginShowClients = input.loginShowClients,
                loginShowTrainers = input.loginShowTrainers,
                loginShowOnTime = input.loginShowOnTime,
                termsMonitoringEnabled = input.termsMonitoringEnabled,
                termsNoticeCooldownDays = input.termsNoticeCooldownDays,
                representatives = input.representatives.map {
                    UpsertAdminCompanyRepresentativeDto(
                        name = it.name.trim(),
                        title = it.title?.trim()?.takeIf { t -> t.isNotEmpty() },
                        docId = it.docId?.trim()?.takeIf { d -> d.isNotEmpty() },
                        staffId = it.staffId,
                    )
                },
                operatingHours = input.operatingHours.map { day ->
                    AdminWorkDayScheduleDto(
                        weekday = day.weekday,
                        blocks = day.blocks.map { b ->
                            AdminWorkTimeBlockDto(startTime = b.startTime, endTime = b.endTime)
                        },
                    )
                },
            ),
        ).toCompany(session)
        return uploadCompanyMedia(input.logo, input.banner) ?: updated
    }

    override suspend fun listSettingsUsers(): List<AdminSettingsUser> =
        get<List<AdminSettingsUserDto>>("/api/settings/users").map { it.toSettingsUser() }

    override suspend fun getSettingsUser(type: AdminSettingsUserType, id: String): AdminSettingsUser =
        get<AdminSettingsUserDto>("/api/settings/users/${type.apiPath()}/$id").toSettingsUser()

    override suspend fun createSettingsUser(input: AdminSettingsUserUpsert): AdminSettingsUser =
        post<AdminSettingsUserDto>(
            "/api/settings/users",
            UpsertAdminSettingsUserRequestDto(
                type = input.type.name,
                displayName = input.displayName.trim(),
                email = input.email?.trim()?.ifBlank { null },
                branchId = input.branchId,
                status = input.status.name,
                password = input.password?.trim()?.ifBlank { null },
                staffRole = input.staffRole?.name,
                inactivationReason = input.inactivationReason,
                inactivationNote = input.inactivationNote,
            ),
        ).toSettingsUser()

    override suspend fun updateSettingsUser(
        type: AdminSettingsUserType,
        id: String,
        input: AdminSettingsUserUpsert,
    ): AdminSettingsUser =
        put<AdminSettingsUserDto>(
            "/api/settings/users/${type.apiPath()}/$id",
            UpsertAdminSettingsUserRequestDto(
                type = input.type.name,
                displayName = input.displayName.trim(),
                email = input.email?.trim()?.ifBlank { null },
                branchId = input.branchId,
                status = input.status.name,
                password = input.password?.trim()?.ifBlank { null },
                staffRole = input.staffRole?.name,
                inactivationReason = input.inactivationReason,
                inactivationNote = input.inactivationNote,
            ),
        ).toSettingsUser()

    override suspend fun deleteSettingsUser(type: AdminSettingsUserType, id: String) {
        deleteNoContent("/api/settings/users/${type.apiPath()}/$id")
    }

    override suspend fun listSettingsRoles(): List<AdminSettingsRole> =
        get<List<AdminSettingsRoleDto>>("/api/settings/roles").map { it.toSettingsRole() }

    override suspend fun getSettingsRole(id: String): AdminSettingsRole =
        get<AdminSettingsRoleDto>("/api/settings/roles/$id").toSettingsRole()

    override suspend fun createSettingsRole(input: AdminSettingsRoleUpsert): AdminSettingsRole =
        post<AdminSettingsRoleDto>(
            "/api/settings/roles",
            UpsertAdminSettingsRoleRequestDto(
                name = input.name.trim(),
                permissions = input.permissions.map { it.name },
            ),
        ).toSettingsRole()

    override suspend fun updateSettingsRole(id: String, input: AdminSettingsRoleUpsert): AdminSettingsRole =
        put<AdminSettingsRoleDto>(
            "/api/settings/roles/$id",
            UpsertAdminSettingsRoleRequestDto(
                name = input.name.trim(),
                permissions = input.permissions.map { it.name },
            ),
        ).toSettingsRole()

    override suspend fun deleteSettingsRole(id: String) {
        deleteNoContent("/api/settings/roles/$id")
    }

    override suspend fun estadoAsistente(): org.gymly.model.AsistenteEstado {
        val dto = get<org.gymly.api.dto.AsistenteEstadoDto>("/api/asistente/estado")
        return org.gymly.model.AsistenteEstado(
            habilitado = dto.habilitado,
            puedeUsar = dto.puedeUsar,
            chatLibre = dto.chatLibre,
        )
    }

    override suspend fun listarConversacionesAsistente(): List<org.gymly.model.AsistenteConversacion> =
        get<List<org.gymly.api.dto.AsistenteConversacionDto>>("/api/asistente/conversaciones").map {
            org.gymly.model.AsistenteConversacion(id = it.id, creadaEn = it.creadaEn, primeraPregunta = it.primeraPregunta)
        }

    override suspend fun leerConversacionAsistente(id: String): List<org.gymly.model.AsistenteMensaje> =
        get<List<org.gymly.api.dto.AsistenteMensajeDto>>("/api/asistente/conversaciones/$id").map {
            org.gymly.model.AsistenteMensaje(rol = it.rol, texto = it.texto, creadoEn = it.creadoEn)
        }

    override suspend fun cambiarEncendidoAsistente(habilitado: Boolean): Boolean =
        put<org.gymly.api.dto.AsistenteEncendidoDto>(
            "/api/asistente/encendido",
            org.gymly.api.dto.AsistenteEncendidoDto(habilitado = habilitado),
        ).habilitado

    override suspend fun preguntarAsistente(
        pregunta: String,
        modo: String,
        conversacionId: String?,
    ): org.gymly.model.AsistenteRespuesta {
        val dto = post<org.gymly.api.dto.AsistenteRespuestaDto>(
            "/api/asistente/preguntas",
            org.gymly.api.dto.AsistentePreguntaDto(
                conversacionId = conversacionId,
                pregunta = pregunta,
                modo = modo,
            ),
        )
        return dto.aModelo()
    }

    override suspend fun getConfiguracionAsistente(): org.gymly.model.AsistenteConfiguracion {
        val dto = get<org.gymly.api.dto.AsistenteConfiguracionDto>("/api/asistente/configuracion")
        return org.gymly.model.AsistenteConfiguracion(
            habilitado = dto.habilitado,
            chatLibre = dto.chatLibre,
            proveedores = dto.proveedores.map { it.aModelo() },
            agentes = dto.agentes.map { it.aModelo() },
            herramientasDisponibles = dto.herramientasDisponibles,
            catalogo = dto.catalogo.map {
                org.gymly.model.AsistenteCatalogo(codigo = it.codigo, nombre = it.nombre, tipo = it.tipo, baseUrl = it.baseUrl)
            },
        )
    }

    override suspend fun eliminarProveedorAsistente(id: String) {
        deleteNoContent("/api/asistente/proveedores/$id")
    }

    override suspend fun crearProveedorAsistente(datos: org.gymly.model.AsistenteDatosProveedor): org.gymly.model.AsistenteProveedor =
        post<org.gymly.api.dto.AsistenteProveedorDto>("/api/asistente/proveedores", datos.aDto()).aModelo()

    override suspend fun actualizarProveedorAsistente(
        id: String,
        datos: org.gymly.model.AsistenteDatosProveedor,
    ): org.gymly.model.AsistenteProveedor =
        put<org.gymly.api.dto.AsistenteProveedorDto>("/api/asistente/proveedores/$id", datos.aDto()).aModelo()

    override suspend fun actualizarAgenteAsistente(
        id: String,
        datos: org.gymly.model.AsistenteDatosAgente,
    ): org.gymly.model.AsistenteAgente {
        val dto = put<org.gymly.api.dto.AsistenteAgenteDto>(
            "/api/asistente/agentes/$id",
            org.gymly.api.dto.AsistenteActualizarAgenteDto(
                activo = datos.activo,
                maxPasos = datos.maxPasos,
                herramientas = datos.herramientas,
                proveedorPrincipalId = datos.proveedorPrincipalId,
                proveedorRespaldoId = datos.proveedorRespaldoId,
            ),
        )
        return dto.aModelo()
    }

    private fun org.gymly.api.dto.AsistenteAgenteDto.aModelo() = org.gymly.model.AsistenteAgente(
        id = id,
        nombre = nombre,
        modo = modo,
        maxPasos = maxPasos,
        herramientas = herramientas,
        activo = activo,
        proveedorPrincipalId = proveedorPrincipalId,
        proveedorRespaldoId = proveedorRespaldoId,
    )

    private fun org.gymly.api.dto.AsistenteProveedorDto.aModelo() = org.gymly.model.AsistenteProveedor(
        id = id,
        nombre = nombre,
        tipo = tipo,
        baseUrl = baseUrl,
        modelo = modelo,
        activo = activo,
        tieneClave = tieneClave,
        limiteMensualCents = limiteMensualCents,
        limiteDiarioTokens = limiteDiarioTokens,
        maxTokensSalida = maxTokensSalida,
        precioEntradaPorMillon = precioEntradaPorMillon,
        precioSalidaPorMillon = precioSalidaPorMillon,
        gastoMesCents = gastoMesCents,
        tokensHoy = tokensHoy,
    )

    private fun org.gymly.model.AsistenteDatosProveedor.aDto() = org.gymly.api.dto.AsistenteDatosProveedorDto(
        nombre = nombre,
        tipo = tipo,
        baseUrl = baseUrl?.takeIf { it.isNotBlank() },
        modelo = modelo,
        activo = activo,
        limiteMensualCents = limiteMensualCents,
        limiteDiarioTokens = limiteDiarioTokens,
        maxTokensSalida = maxTokensSalida,
        precioEntradaPorMillon = precioEntradaPorMillon,
        precioSalidaPorMillon = precioSalidaPorMillon,
        clave = clave?.takeIf { it.isNotBlank() },
    )

    override suspend fun modelosDisponiblesAsistente(
        tipo: String,
        baseUrl: String?,
        clave: String?,
        proveedorId: String?,
    ): List<String> = post<List<String>>(
        "/api/asistente/modelos-disponibles",
        org.gymly.api.dto.AsistenteModelosRequestDto(
            tipo = tipo,
            baseUrl = baseUrl,
            clave = clave?.takeIf { it.isNotBlank() },
            proveedorId = proveedorId,
        ),
    )

    override suspend fun obtenerPersonalizacionAsistente(): org.gymly.model.AsistentePersonalizacion {
        val dto = get<org.gymly.api.dto.AsistentePersonalizacionDto>("/api/asistente/personalizacion")
        return org.gymly.model.AsistentePersonalizacion(nombre = dto.nombre, color = dto.color, logoUrl = dto.logoUrl)
    }

    override suspend fun guardarPersonalizacionAsistente(
        datos: org.gymly.model.AsistentePersonalizacion,
    ): org.gymly.model.AsistentePersonalizacion {
        val dto = put<org.gymly.api.dto.AsistentePersonalizacionDto>(
            "/api/asistente/personalizacion",
            org.gymly.api.dto.AsistentePersonalizacionDto(nombre = datos.nombre, color = datos.color, logoUrl = datos.logoUrl),
        )
        return org.gymly.model.AsistentePersonalizacion(nombre = dto.nombre, color = dto.color, logoUrl = dto.logoUrl)
    }

    override suspend fun preguntasSinRespuestaAsistente(): List<org.gymly.model.AsistentePreguntaSinRespuesta> =
        get<List<org.gymly.api.dto.AsistentePreguntaSinRespuestaDto>>("/api/asistente/sin-respuesta").map {
            org.gymly.model.AsistentePreguntaSinRespuesta(pregunta = it.pregunta, veces = it.veces, ultima = it.ultima)
        }

    override suspend fun auditarConversacionesAsistente(): List<org.gymly.model.AsistenteConversacionAuditada> =
        get<List<org.gymly.api.dto.AsistenteConversacionAuditadaDto>>("/api/asistente/auditoria/conversaciones").map {
            org.gymly.model.AsistenteConversacionAuditada(
                id = it.id, usuario = it.usuario, creadaEn = it.creadaEn, primeraPregunta = it.primeraPregunta,
            )
        }

    override suspend fun abrirConversacionAuditadaAsistente(id: String): List<org.gymly.model.AsistenteMensaje> =
        get<List<org.gymly.api.dto.AsistenteMensajeDto>>("/api/asistente/auditoria/conversaciones/$id").map {
            org.gymly.model.AsistenteMensaje(rol = it.rol, texto = it.texto, creadoEn = it.creadoEn)
        }

    override suspend fun preguntarRapidaAsistente(clave: String, conversacionId: String?): org.gymly.model.AsistenteRespuesta {
        val dto = post<org.gymly.api.dto.AsistenteRespuestaDto>(
            "/api/asistente/rapidas",
            org.gymly.api.dto.AsistenteRapidaDto(conversacionId = conversacionId, clave = clave),
        )
        return dto.aModelo()
    }

    private fun org.gymly.api.dto.AsistenteRespuestaDto.aModelo() = org.gymly.model.AsistenteRespuesta(
        conversacionId = conversacionId,
        texto = texto,
        herramientasUsadas = herramientasUsadas,
    )

    override suspend fun listPendingApprovals(): List<AdminApprovalRequest> =
        get<List<AdminApprovalRequestDto>>("/api/approvals/pending").map { it.toModel() }

    override suspend fun listMyApprovals(): List<AdminApprovalRequest> =
        get<List<AdminApprovalRequestDto>>("/api/approvals/mine").map { it.toModel() }

    override suspend fun pendingApprovalsCount(): Long =
        get<AdminApprovalPendingCountDto>("/api/approvals/pending/count").count

    override suspend fun approveRequest(id: String, note: String?): AdminApprovalRequest =
        post<AdminApprovalRequestDto>("/api/approvals/$id/approve", AdminApprovalReviewDto(note)).toModel()

    override suspend fun rejectRequest(id: String, note: String?): AdminApprovalRequest =
        post<AdminApprovalRequestDto>("/api/approvals/$id/reject", AdminApprovalReviewDto(note)).toModel()

    override suspend fun getSettingsMail(): AdminSettingsMail =
        get<AdminSettingsMailDto>("/api/settings/mail").toSettingsMail()

    override suspend fun createSettingsMail(input: AdminSettingsMailUpsert): AdminSettingsMail =
        post<AdminSettingsMailDto>("/api/settings/mail", input.toDto()).toSettingsMail()

    override suspend fun upsertSettingsMail(input: AdminSettingsMailUpsert): AdminSettingsMail =
        put<AdminSettingsMailDto>("/api/settings/mail", input.toDto()).toSettingsMail()

    override suspend fun updateSettingsMail(id: String, input: AdminSettingsMailUpsert): AdminSettingsMail =
        put<AdminSettingsMailDto>("/api/settings/mail/$id", input.toDto()).toSettingsMail()

    override suspend fun deleteSettingsMail(id: String?) {
        if (id.isNullOrBlank()) {
            deleteNoContent("/api/settings/mail")
        } else {
            deleteNoContent("/api/settings/mail/$id")
        }
    }

    override suspend fun getSettingsWhatsApp(): org.gymly.model.AdminSettingsWhatsApp =
        get<org.gymly.api.dto.AdminSettingsWhatsAppDto>("/api/settings/whatsapp").toSettingsWhatsApp()

    override suspend fun upsertSettingsWhatsApp(
        input: org.gymly.model.AdminSettingsWhatsAppUpsert,
    ): org.gymly.model.AdminSettingsWhatsApp =
        put<org.gymly.api.dto.AdminSettingsWhatsAppDto>(
            "/api/settings/whatsapp",
            org.gymly.api.dto.UpsertAdminSettingsWhatsAppRequestDto(
                enabled = input.enabled,
                apiBaseUrl = input.apiBaseUrl,
                apiVersion = input.apiVersion,
                phoneNumberId = input.phoneNumberId,
                accessToken = input.accessToken,
                templateName = input.templateName,
                templateLanguage = input.templateLanguage,
                templateWelcome = input.templateWelcome,
                templatePaymentReceived = input.templatePaymentReceived,
                templatePaymentPending = input.templatePaymentPending,
                templateMembershipExpiring = input.templateMembershipExpiring,
                templateMarketing = input.templateMarketing,
                templateTermsNotice = input.templateTermsNotice,
                templateTermsNoticeApproved = input.templateTermsNoticeApproved,
                sendHour = input.sendHour,
                saturdayEnabled = input.saturdayEnabled,
                sundayEnabled = input.sundayEnabled,
                simulateOnly = input.simulateOnly,
            ),
        ).toSettingsWhatsApp()

    override suspend fun runWhatsAppWeeklyRemindersNow(): org.gymly.model.AdminWhatsAppRunNowResult =
        post<org.gymly.api.dto.AdminWhatsAppRunNowResultDto>(
            "/api/settings/whatsapp/run-now",
            emptyMap<String, String>(),
        ).let { org.gymly.model.AdminWhatsAppRunNowResult(sentCount = it.sentCount) }

    override suspend fun getSettingsPayments(): AdminSettingsPayment =
        get<AdminSettingsPaymentDto>("/api/settings/payments").toSettingsPayment()

    override suspend fun upsertSettingsPayments(input: AdminSettingsPaymentUpsert): AdminSettingsPayment =
        put<AdminSettingsPaymentDto>(
            "/api/settings/payments",
            UpsertAdminSettingsPaymentRequestDto(
                paypalEnabled = input.paypalEnabled,
                paypalClientId = input.paypalClientId?.trim()?.ifBlank { null },
                paypalSecret = input.paypalSecret?.trim()?.ifBlank { null },
                paypalMode = input.paypalMode.name,
                stripeEnabled = input.stripeEnabled,
                stripePublicKey = input.stripePublicKey?.trim()?.ifBlank { null },
                stripeSecretKey = input.stripeSecretKey?.trim()?.ifBlank { null },
            ),
        ).toSettingsPayment()

    override suspend fun deleteSettingsPayments(id: String?) {
        if (id.isNullOrBlank()) {
            deleteNoContent("/api/settings/payments")
        } else {
            deleteNoContent("/api/settings/payments/$id")
        }
    }

    override suspend fun listPaymentMethodTypes(): AdminPaymentMethodsBundle =
        get<AdminPaymentMethodsBundleDto>("/api/settings/payment-methods").toPaymentMethodsBundle(session)

    override suspend fun updatePaymentMethodType(
        code: String,
        input: AdminPaymentMethodTypeUpsert,
    ): AdminPaymentMethodType =
        put<AdminPaymentMethodTypeDto>(
            "/api/settings/payment-methods/$code",
            UpsertAdminPaymentMethodTypeRequestDto(
                title = input.title,
                description = input.description?.trim()?.ifBlank { null },
                enabled = input.enabled,
                sortOrder = input.sortOrder,
                requiresPhone = input.requiresPhone,
                requiresReference = input.requiresReference,
                requiresProof = input.requiresProof,
                autoApprove = input.autoApprove,
                amountLabel = input.amountLabel?.trim()?.ifBlank { null },
                provider = input.provider?.trim()?.ifBlank { null },
                usesForeignCurrency = input.usesForeignCurrency,
                foreignCurrencyCode = input.foreignCurrencyCode?.trim()?.ifBlank { null },
            ),
        ).toPaymentMethodType(session)

    override suspend fun createPaymentMethodType(input: AdminPaymentMethodTypeCreate): AdminPaymentMethodType =
        post<AdminPaymentMethodTypeDto>(
            "/api/settings/payment-methods",
            CreateAdminPaymentMethodTypeRequestDto(
                code = input.code.trim().uppercase(),
                title = input.title,
                description = input.description?.trim()?.ifBlank { null },
                enabled = input.enabled,
                sortOrder = input.sortOrder,
                requiresPhone = input.requiresPhone,
                requiresReference = input.requiresReference,
                requiresProof = input.requiresProof,
                autoApprove = input.autoApprove,
                amountLabel = input.amountLabel?.trim()?.ifBlank { null },
                provider = input.provider?.trim()?.ifBlank { null },
                usesForeignCurrency = input.usesForeignCurrency,
                foreignCurrencyCode = input.foreignCurrencyCode?.trim()?.ifBlank { null },
            ),
        ).toPaymentMethodType(session)

    override suspend fun deletePaymentMethodType(code: String) {
        deleteNoContent("/api/settings/payment-methods/$code")
    }

    override suspend fun getSettingsModules(): AdminSettingsModules =
        get<AdminSettingsModulesDto>("/api/settings/modules").toModules()

    override suspend fun updateSettingsModules(input: AdminSettingsModulesUpsert): AdminSettingsModules =
        put<AdminSettingsModulesDto>(
            "/api/settings/modules",
            UpdateAdminSettingsModulesDto(
                accessEnabled = input.accessEnabled,
                exchangeRatesEnabled = input.exchangeRatesEnabled,
                suppressAccessWhileCapturing = input.suppressAccessWhileCapturing,
                clientAccountsEnabled = input.clientAccountsEnabled,
                schedulesAutomatic = input.schedulesAutomatic,
                membershipAccessGraceDays = input.membershipAccessGraceDays,
                exchangePanelVisible = input.exchangePanelVisible,
            ),
        ).toModules()

    override suspend fun getProductLicenseStatus(): AdminProductLicenseStatus =
        get<AdminProductLicenseStatusDto>("/api/license/status").toModel()

    override suspend fun activateProductLicense(licenseCode: String): AdminProductLicenseStatus =
        post<AdminProductLicenseStatusDto>(
            "/api/license/activate",
            ActivateAdminProductLicenseDto(licenseCode = licenseCode),
        ).toModel()

    override suspend fun uploadPaymentMethodTypeImage(
        code: String,
        image: PickedImagePayload,
    ): AdminPaymentMethodType {
        val response = client.post(url("/api/settings/payment-methods/$code/image")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminPaymentMethodTypeDto>().toPaymentMethodType(session)
    }

    override suspend fun upsertPaymentMethodGateways(input: AdminSettingsPaymentUpsert): AdminSettingsPayment =
        put<AdminSettingsPaymentDto>(
            "/api/settings/payment-methods/gateways",
            UpsertAdminSettingsPaymentRequestDto(
                paypalEnabled = input.paypalEnabled,
                paypalClientId = input.paypalClientId?.trim()?.ifBlank { null },
                paypalSecret = input.paypalSecret?.trim()?.ifBlank { null },
                paypalMode = input.paypalMode.name,
                stripeEnabled = input.stripeEnabled,
                stripePublicKey = input.stripePublicKey?.trim()?.ifBlank { null },
                stripeSecretKey = input.stripeSecretKey?.trim()?.ifBlank { null },
            ),
        ).toSettingsPayment()

    override suspend fun listSettingsNotificationRules(): List<AdminSettingsNotificationRule> =
        get<List<AdminSettingsNotificationRuleDto>>("/api/settings/notifications").map { it.toRule() }

    override suspend fun replaceSettingsNotificationRules(
        rules: List<AdminSettingsNotificationRuleUpsert>,
    ): List<AdminSettingsNotificationRule> =
        put<List<AdminSettingsNotificationRuleDto>>(
            "/api/settings/notifications",
            ReplaceAdminSettingsNotificationRulesRequestDto(
                rules = rules.map {
                    UpsertAdminSettingsNotificationRuleDto(
                        eventCode = it.eventCode.name,
                        emailEnabled = it.emailEnabled,
                        pushEnabled = it.pushEnabled,
                        webEnabled = it.webEnabled,
                    )
                },
            ),
        ).map { it.toRule() }

    override suspend fun listSettingsNotificationSchedules(): List<org.gymly.model.AdminSettingsNotificationSchedule> =
        get<List<org.gymly.api.dto.AdminSettingsNotificationScheduleDto>>("/api/settings/notification-schedules")
            .map { it.toNotificationSchedule() }

    override suspend fun replaceSettingsNotificationSchedules(
        schedules: List<org.gymly.model.AdminSettingsNotificationScheduleUpsert>,
    ): List<org.gymly.model.AdminSettingsNotificationSchedule> =
        put<List<org.gymly.api.dto.AdminSettingsNotificationScheduleDto>>(
            "/api/settings/notification-schedules",
            schedules.map {
                org.gymly.api.dto.UpsertAdminSettingsNotificationScheduleDto(
                    eventCode = it.eventCode.name,
                    enabled = it.enabled,
                    frequency = it.frequency.name,
                    sendHour = it.sendHour,
                    mondayEnabled = it.mondayEnabled,
                    tuesdayEnabled = it.tuesdayEnabled,
                    wednesdayEnabled = it.wednesdayEnabled,
                    thursdayEnabled = it.thursdayEnabled,
                    fridayEnabled = it.fridayEnabled,
                    saturdayEnabled = it.saturdayEnabled,
                    sundayEnabled = it.sundayEnabled,
                    leadDays = it.leadDays,
                    timezone = it.timezone,
                    inactivateAfterDays = it.inactivateAfterDays,
                )
            },
        ).map { it.toNotificationSchedule() }

    override suspend fun listSettingsNotificationTemplates(): List<AdminSettingsNotificationTemplate> =
        get<List<AdminSettingsNotificationTemplateDto>>("/api/settings/notification-templates").map { it.toTemplate() }

    override suspend fun getSettingsNotificationTemplate(
        eventCode: AdminNotificationEventCode,
    ): AdminSettingsNotificationTemplate =
        get<AdminSettingsNotificationTemplateDto>("/api/settings/notification-templates/${eventCode.name}").toTemplate()

    override suspend fun upsertSettingsNotificationTemplate(
        input: AdminSettingsNotificationTemplateUpsert,
    ): AdminSettingsNotificationTemplate =
        put<AdminSettingsNotificationTemplateDto>(
            "/api/settings/notification-templates",
            UpsertAdminSettingsNotificationTemplateDto(
                eventCode = input.eventCode.name,
                emailSubject = input.emailSubject,
                emailBodyText = input.emailBodyText,
                webTitle = input.webTitle,
                webBody = input.webBody,
            ),
        ).toTemplate()

    override suspend fun resetSettingsNotificationTemplate(
        eventCode: AdminNotificationEventCode,
    ): AdminSettingsNotificationTemplate =
        post<AdminSettingsNotificationTemplateDto>(
            "/api/settings/notification-templates/${eventCode.name}/reset",
            emptyMap<String, String>(),
        ).toTemplate()

    override suspend fun notificationTemplateVariablesHelp(): String =
        get<AdminNotificationTemplateVariablesDto>("/api/settings/notification-templates/variables").help

    override suspend fun listAccessTerminals(): List<AdminAccessTerminal> =
        get<List<AdminAccessTerminalDto>>("/api/access/terminals").map { it.toTerminal() }

    override suspend fun createAccessTerminal(input: AdminAccessTerminalUpsert): AdminAccessTerminal =
        post<AdminAccessTerminalDto>("/api/access/terminals", input.toDto()).toTerminal()

    override suspend fun updateAccessTerminal(id: String, input: AdminAccessTerminalUpsert): AdminAccessTerminal =
        put<AdminAccessTerminalDto>("/api/access/terminals/$id", input.toDto()).toTerminal()

    override suspend fun deleteAccessTerminal(id: String) =
        deleteNoContent("/api/access/terminals/$id")

    override suspend fun testAccessTerminal(id: String): AdminAccessTestResult {
        val d = post<AdminAccessTestDto>("/api/access/terminals/$id/test", emptyMap<String, String>())
        return AdminAccessTestResult(ok = d.ok, message = d.message.orEmpty())
    }

    override suspend fun configureAccessTerminalWebhook(id: String): AdminAccessTestResult {
        val d = post<AdminAccessTestDto>("/api/access/terminals/$id/configure-webhook", emptyMap<String, String>())
        return AdminAccessTestResult(ok = d.ok, message = d.message.orEmpty())
    }

    override suspend fun captureFaceFromTerminal(terminalId: String): PickedImagePayload {
        val d = post<AdminCaptureFaceDto>(
            "/api/access/terminals/$terminalId/capture-face",
            emptyMap<String, String>(),
        )
        val bytes = decodeCaptureFaceBase64(d.bytesBase64)
        return PickedImagePayload(
            bytes = bytes,
            fileName = d.fileName.ifBlank { "terminal-capture.jpg" },
            mimeType = d.contentType.ifBlank { "image/jpeg" },
        )
    }

    override suspend fun simulateAccessCheckIn(
        terminalId: String,
        clientId: String?,
        staffId: String?,
    ): AdminAccessEvent =
        post<AdminAccessEventDto>(
            "/api/access/terminals/$terminalId/simulate",
            AdminAccessSimulateRequestDto(clientId = clientId, staffId = staffId),
        ).toEvent()

    override suspend fun closeAccessDoor(terminalId: String?): AdminAccessTestResult {
        val path = if (terminalId.isNullOrBlank()) {
            "/api/access/close-door"
        } else {
            "/api/access/terminals/$terminalId/close-door"
        }
        val d = post<AdminAccessTestDto>(path, emptyMap<String, String>())
        return AdminAccessTestResult(ok = d.ok, message = d.message.orEmpty())
    }

    override suspend fun listAccessEvents(limit: Int): List<AdminAccessEvent> =
        get<List<AdminAccessEventDto>>("/api/access/events?limit=$limit").map { it.toEvent() }

    override suspend fun syncClientAccess(clientId: String): AdminAccessSyncResult {
        val d = post<AdminAccessSyncDto>("/api/access/clients/$clientId/sync", emptyMap<String, String>())
        return AdminAccessSyncResult(
            clientId = d.clientId,
            accessSyncedAt = d.accessSyncedAt,
            accessSyncError = d.accessSyncError,
        )
    }

    override suspend fun syncStaffAccess(staffId: String): AdminAccessSyncResult {
        val d = post<AdminStaffAccessSyncDto>("/api/access/staff/$staffId/sync", emptyMap<String, String>())
        return AdminAccessSyncResult(
            clientId = d.staffId,
            accessSyncedAt = d.accessSyncedAt,
            accessSyncError = d.accessSyncError,
        )
    }

    override suspend fun listProductCategories(): List<AdminProductCategoryItem> =
        get<List<AdminProductCategoryDto>>("/api/products/categories").map {
            AdminProductCategoryItem(id = it.id, name = it.name, sortOrder = it.sortOrder, productCount = it.productCount)
        }

    override suspend fun createProductCategory(name: String): AdminProductCategoryItem {
        val created = post<AdminProductCategoryDto>(
            "/api/products/categories",
            UpsertAdminProductCategoryRequestDto(name.trim()),
        )
        return AdminProductCategoryItem(id = created.id, name = created.name, sortOrder = created.sortOrder, productCount = created.productCount)
    }

    override suspend fun updateProductCategory(id: String, name: String): AdminProductCategoryItem {
        val updated = put<AdminProductCategoryDto>(
            "/api/products/categories/$id",
            UpsertAdminProductCategoryRequestDto(name.trim()),
        )
        return AdminProductCategoryItem(id = updated.id, name = updated.name, sortOrder = updated.sortOrder, productCount = updated.productCount)
    }

    override suspend fun deleteProductCategory(id: String) {
        deleteNoContent("/api/products/categories/$id")
    }

    override suspend fun isAIEnabled(): Boolean = get<Map<String, Boolean>>("/api/system/features")["AI_ENABLED"] ?: false
    override suspend fun setAIEnabled(enabled: Boolean) = post<Unit>("/api/system/ai-enabled", enabled)

    override suspend fun listAIProviders(): List<org.gymly.ai.model.AIProvider> = get("/api/admin/ai-config/providers")

    override suspend fun setupAIProvider(input: org.gymly.api.dto.AdminAiProviderSetupRequestDto): String =
        post<String>("/api/admin/ai-config/setup", input)

    override suspend fun listAIAgents(): List<org.gymly.ai.model.AIAgent> = get("/api/admin/ai-config/agents")

    override suspend fun createAIAgent(agent: org.gymly.ai.model.AIAgent): org.gymly.ai.model.AIAgent = post("/api/admin/ai-config/agents", agent)

    override suspend fun updateAIProvider(id: Long, provider: org.gymly.ai.model.AIProvider): org.gymly.ai.model.AIProvider =
        put("/api/admin/ai-config/providers/$id", provider)

    override suspend fun deleteAIProvider(id: Long) = deleteNoContent("/api/admin/ai-config/providers/$id")

    override suspend fun updateAIAgent(id: Long, agent: org.gymly.ai.model.AIAgent): org.gymly.ai.model.AIAgent =
        put("/api/admin/ai-config/agents/$id", agent)

    override suspend fun deleteAIAgent(id: Long) = deleteNoContent("/api/admin/ai-config/agents/$id")

    override suspend fun listAgentFeatures(agentId: Long): List<org.gymly.ai.model.AIAgentFeature> =
        get("/api/admin/ai-config/agents/$agentId/features")

    override suspend fun updateAgentFeature(
        agentId: Long,
        featureId: Long,
        update: org.gymly.ai.model.AIAgentFeatureUpdate
    ): org.gymly.ai.model.AIAgentFeature =
        put("/api/admin/ai-config/agents/$agentId/features/$featureId", update)

    override suspend fun listAIAuditLogs(): List<org.gymly.ai.model.AIAuditLog> =
        get("/api/admin/ai-config/audit-logs")

    override suspend fun getExecutiveReport(): String =
        get<AiReportResponseDto>("/api/admin/ai-agents/bi/report").report

    override suspend fun suggestPassword(): String =
        get<org.gymly.api.dto.PasswordSuggestionDto>("/api/staff/password-suggestion").password

    override suspend fun listProducts(): List<AdminProduct> =
        get<List<AdminProductDto>>("/api/products").map { it.toProduct(session) }

    override suspend fun getProduct(id: String): AdminProduct =
        get<AdminProductDto>("/api/products/$id").toProduct(session)

    override suspend fun createProduct(input: AdminProductUpsert): AdminProduct =
        post<AdminProductDto>(
            "/api/products",
            UpsertAdminProductRequestDto(
                name = input.name.trim(),
                category = input.category,
                priceCents = input.priceCents,
                priceUsdCents = input.priceUsdCents,
                currency = input.currency,
                stockQty = input.stockQty,
                minStockQty = input.minStockQty,
                description = input.description?.trim()?.ifBlank { null },
                active = input.active,
                branchId = input.branchId,
                ingredients = input.ingredients?.trim()?.ifBlank { null },
                videoUrl = input.videoUrl?.trim()?.ifBlank { null },
            ),
        ).toProduct(session).let { created ->
            input.image?.let { postProductImage(created.id, it) } ?: created
        }

    override suspend fun updateProduct(id: String, input: AdminProductUpsert): AdminProduct =
        put<AdminProductDto>(
            "/api/products/$id",
            UpsertAdminProductRequestDto(
                name = input.name.trim(),
                category = input.category,
                priceCents = input.priceCents,
                priceUsdCents = input.priceUsdCents,
                currency = input.currency,
                stockQty = input.stockQty,
                minStockQty = input.minStockQty,
                description = input.description?.trim()?.ifBlank { null },
                active = input.active,
                branchId = input.branchId,
                ingredients = input.ingredients?.trim()?.ifBlank { null },
                videoUrl = input.videoUrl?.trim()?.ifBlank { null },
            ),
        ).toProduct(session).let { updated ->
            input.image?.let { postProductImage(id, it) } ?: updated
        }

    override suspend fun deleteProduct(id: String) {
        deleteNoContent("/api/products/$id")
    }

    override suspend fun paymentReferencesOnDay(dateIso: String): List<org.gymly.api.dto.AdminPaymentReferenceDto> =
        get("/api/payments/references?date=$dateIso")

    override suspend fun listStoreSales(): List<AdminStoreSale> =
        get<List<AdminStoreSaleDto>>("/api/store-sales").map { it.toStoreSale(session) }

    override suspend fun getStoreSale(id: String): AdminStoreSale =
        get<AdminStoreSaleDto>("/api/store-sales/$id").toStoreSale(session)

    override suspend fun createStoreSale(input: AdminStoreSaleUpsert): AdminStoreSale =
        post<AdminStoreSaleDto>("/api/store-sales", input.toDto()).toStoreSale(session)

    override suspend fun updateStoreSale(id: String, input: AdminStoreSaleUpsert): AdminStoreSale =
        put<AdminStoreSaleDto>("/api/store-sales/$id", input.toDto()).toStoreSale(session)

    override suspend fun recordStoreSalePayment(id: String, input: AdminStoreSaleUpsert): AdminStoreSale =
        post<AdminStoreSaleDto>("/api/store-sales/$id/payment", input.toDto()).toStoreSale(session)

    override suspend fun approveStoreSale(id: String, status: AdminStoreSaleStatus): AdminStoreSale =
        post<AdminStoreSaleDto>(
            "/api/store-sales/$id/approve",
            ApproveAdminStoreSaleRequestDto(status = status.name),
        ).toStoreSale(session)

    override suspend fun validateStoreSaleProof(id: String, paid: Boolean, reason: String?) {
        post<ProofValidationResponseDto>("/api/store-sales/$id/validate", proofValidationBody(paid, reason))
    }

    override suspend fun validatePaymentProof(id: String, paid: Boolean, reason: String?) {
        post<ProofValidationResponseDto>("/api/payments/$id/validate", proofValidationBody(paid, reason))
    }

    private fun proofValidationBody(paid: Boolean, reason: String?) = ProofValidationRequestDto(
        decision = if (paid) "PAID" else "FAILED",
        reason = reason?.trim()?.takeIf { it.isNotEmpty() },
    )

    override suspend fun uploadStoreSaleProof(id: String, image: PickedImagePayload): AdminStoreSale {
        val response = client.post(url("/api/store-sales/$id/proof")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminStoreSaleDto>().toStoreSale(session)
    }

    override suspend fun deleteStoreSale(id: String) {
        deleteNoContent("/api/store-sales/$id")
    }

    override suspend fun downloadStoreSaleInvoice(id: String): AdminStoreSaleInvoiceFile {
        val response = client.get(url("/api/store-sales/$id/invoice.pdf"))
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val bytes = response.body<ByteArray>()
        val disposition = response.headers[HttpHeaders.ContentDisposition].orEmpty()
        val fileName = parseContentDispositionFileName(disposition, "factura-venta.pdf")
        val mime = response.headers[HttpHeaders.ContentType]?.substringBefore(';')?.trim()
            ?: "application/pdf"
        return AdminStoreSaleInvoiceFile(fileName = fileName, mimeType = mime, bytes = bytes)
    }

    override suspend fun emailStoreSaleInvoice(id: String) {
        post<Map<String, String>>("/api/store-sales/$id/invoice/email", emptyMap<String, String>())
    }

    override suspend fun listMembershipOrders(): List<AdminMembershipOrder> =
        get<List<AdminMembershipOrderDto>>("/api/membership-orders").map { it.toMembershipOrder(session) }

    override suspend fun getMembershipOrder(id: String): AdminMembershipOrder =
        get<AdminMembershipOrderDto>("/api/membership-orders/$id").toMembershipOrder(session)

    override suspend fun isMembershipPeriodCovered(
        clientId: String,
        planId: String,
        orderDate: String,
        excludeOrderId: String?,
    ): Boolean {
        val exclude = excludeOrderId?.takeIf { it.isNotBlank() }?.let { "&excludeOrderId=$it" }.orEmpty()
        return get<org.gymly.api.dto.AdminMembershipPeriodCoveredDto>(
            "/api/membership-orders/period-covered?clientId=$clientId&planId=$planId&orderDate=$orderDate$exclude",
        ).covered
    }

    override suspend fun createMembershipOrder(input: AdminMembershipOrderUpsert): AdminMembershipOrder {
        val response = client.post(url("/api/membership-orders")) {
            contentType(ContentType.Application.Json)
            setBody(input.toDto())
        }
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminMembershipOrderDto>().toMembershipOrder(session)
    }

    override suspend fun recordMembershipOrderPayment(
        id: String,
        status: AdminMembershipOrderStatus,
        method: AdminPaymentMethod?,
        pendingUsdCents: Long,
        pendingBsCents: Long,
    ): AdminMembershipOrder {
        val response = client.post(url("/api/membership-orders/$id/payment")) {
            contentType(ContentType.Application.Json)
            setBody(
                RecordAdminMembershipOrderPaymentRequestDto(
                    status = status.name,
                    method = method?.name,
                    pendingUsdCents = pendingUsdCents.coerceAtLeast(0L),
                    pendingBsCents = pendingBsCents.coerceAtLeast(0L),
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminMembershipOrderDto>().toMembershipOrder(session)
    }

    override suspend fun updateMembershipOrderPaymentDate(
        orderId: String,
        paymentId: String,
        paidAt: String,
    ): AdminMembershipOrder {
        val response = client.put(url("/api/membership-orders/$orderId/payments/$paymentId/paid-at")) {
            contentType(ContentType.Application.Json)
            setBody(UpdateAdminMembershipOrderPaymentDateRequestDto(paidAt = paidAt))
        }
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminMembershipOrderDto>().toMembershipOrder(session)
    }

    override suspend fun updateMembershipOrder(id: String, input: AdminMembershipOrderUpsert): AdminMembershipOrder {
        val response = client.put(url("/api/membership-orders/$id")) {
            contentType(ContentType.Application.Json)
            setBody(input.toDto())
        }
        throwIfPendingApproval(response)
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminMembershipOrderDto>().toMembershipOrder(session)
    }

    override suspend fun markMembershipOrderPaid(id: String): AdminMembershipOrder =
        post<AdminMembershipOrderDto>("/api/membership-orders/$id/mark-paid", emptyMap<String, String>())
            .toMembershipOrder(session)

    override suspend fun uploadMembershipOrderProof(id: String, image: PickedImagePayload): AdminMembershipOrder {
        val response = client.post(url("/api/membership-orders/$id/proof")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminMembershipOrderDto>().toMembershipOrder(session)
    }

    override suspend fun deleteMembershipOrder(id: String) {
        deleteNoContent("/api/membership-orders/$id")
    }

    override suspend fun cleanupOrphanMembershipPayments(): Int {
        val body = post<Map<String, Int>>("/api/membership-orders/cleanup-orphan-payments", emptyMap<String, String>())
        return body["removed"] ?: 0
    }

    override suspend fun downloadPaymentReceipt(id: String): AdminPaymentReceiptFile {
        val response = client.get(url("/api/payments/$id/receipt.pdf"))
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val bytes = response.body<ByteArray>()
        val disposition = response.headers[HttpHeaders.ContentDisposition].orEmpty()
        val fileName = parseContentDispositionFileName(disposition, "recibo-pago.pdf")
        val mime = response.headers[HttpHeaders.ContentType]?.substringBefore(';')?.trim()
            ?: "application/pdf"
        return AdminPaymentReceiptFile(fileName = fileName, mimeType = mime, bytes = bytes)
    }

    override suspend fun emailPaymentReceipt(id: String) {
        post<Map<String, String>>("/api/payments/$id/receipt/email", emptyMap<String, String>())
    }

    private fun AdminStoreSaleUpsert.toDto() = UpsertAdminStoreSaleRequestDto(
        clientId = clientId,
        walkInName = walkInName?.trim()?.ifBlank { null },
        branchId = branchId,
        method = method.name,
        origin = origin.name,
        status = status?.name,
        saleDate = saleDate,
        currency = currency,
        notes = notes?.trim()?.ifBlank { null },
        amountPaidCents = amountPaidCents?.takeIf { it > 0 },
        changeGivenCents = changeGivenCents.takeIf { it > 0 },
        foreignUsdCents = foreignUsdCents?.takeIf { it > 0 },
        payments = payments?.map {
            AdminStorePaymentLineDto(method = it.method.name, currency = it.currency, amountCents = it.amountCents)
        },
        // El pendiente en 0 se envía como 0 (no como nulo): el servidor lo exige explícito.
        pendingBsCents = pendingBsCents.coerceAtLeast(0L),
        pendingUsdCents = pendingUsdCents.coerceAtLeast(0L),
        discount = discount?.toCollectDiscountDto(),
        items = items.map {
            UpsertAdminStoreSaleItemDto(
                productId = it.productId,
                productName = it.productName?.trim()?.ifBlank { null },
                qty = it.qty,
                unitPriceCents = it.unitPriceCents,
            )
        },
    )

    private fun AdminMembershipOrderUpsert.toDto() = UpsertAdminMembershipOrderRequestDto(
        clientId = clientId,
        planId = planId,
        branchId = branchId,
        trainerId = trainerId,
        method = method?.name,
        payerPhone = payerPhone?.trim()?.ifBlank { null },
        origin = origin.name,
        status = status?.name,
        orderDate = orderDate,
        amountCents = amountCents,
        currency = currency,
        pendingUsdCents = pendingUsdCents,
        pendingBsCents = pendingBsCents,
        notes = notes?.trim()?.ifBlank { null },
        collect = collect?.toCollectDto(),
        paymentDates = paymentDates.map { AdminMembershipOrderPaymentDateDto(it.paymentId, it.paidAt) }
            .ifEmpty { null },
        endsAt = endsAt,
    )

    /** Descuento del cobro de orden de membresía, en el formato que espera el backend. */
    private fun AdminPaymentDiscount.toCollectDiscountDto() = CollectAdminDiscountDto(
        cents = cents,
        reason = reason,
        note = note,
        usdCents = usdCents,
    )

    private fun AdminPaymentCollect.toCollectDto() = CollectAdminPaymentRequestDto(
        currency = currency,
        discount = discount?.toCollectDiscountDto(),
        targets = targets.map { t ->
            CollectAdminPaymentTargetDto(
                orderId = t.orderId,
                clientId = t.clientId,
                membershipOrderId = t.membershipOrderId,
                amountCents = t.amountCents,
                planId = t.planId,
                branchId = t.branchId,
                trainerId = t.trainerId,
                discount = t.discount?.toCollectDiscountDto(),
            )
        },
        lines = lines.map { l ->
            CollectAdminPaymentLineDto(
                method = l.method.name,
                amountCents = l.amountCents,
                foreignUsdCents = l.foreignUsdCents,
                payerPhone = l.payerPhone,
                notes = l.notes,
                proofPath = l.proofPath,
            )
        },
        paidAt = paidAt,
        changeGivenCents = changeGivenCents.takeIf { it > 0 },
        changeGivenUsdCents = changeGivenUsdCents.takeIf { it > 0 },
    )

    private fun AdminSettingsMailUpsert.toDto() = UpsertAdminSettingsMailRequestDto(
        host = host.trim(),
        port = port,
        username = username?.trim()?.ifBlank { null },
        fromAddress = fromAddress?.trim()?.ifBlank { null },
        password = password?.trim()?.ifBlank { null },
        securityMode = securityMode.name,
        useTls = useTls,
    )

    private suspend fun uploadBranchMedia(
        id: String,
        logo: PickedImagePayload?,
        banner: PickedImagePayload?,
    ): AdminBranch? {
        var latest: AdminBranch? = null
        if (logo != null) {
            latest = postMultipartImage("/api/branches/$id/logo", logo)
        }
        if (banner != null) {
            latest = postMultipartImage("/api/branches/$id/banner", banner)
        }
        return latest
    }

    private suspend fun postCatalogImage(path: String, image: PickedImagePayload): AdminCatalogService {
        val response = client.post(url(path)) {
            setBody(MultiPartFormDataContent(formData { appendUploadFile("file", image) }))
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminServiceDto>().toCatalog()
    }

    private suspend fun postProductImage(id: String, image: PickedImagePayload): AdminProduct {
        val response = client.post(url("/api/products/$id/image")) {
            setBody(MultiPartFormDataContent(formData { appendUploadFile("file", image) }))
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminProductDto>().toProduct(session)
    }

    private suspend fun uploadCompanyMedia(
        logo: PickedImagePayload?,
        banner: PickedImagePayload?,
    ): AdminCompany? {
        var latest: AdminCompany? = null
        if (logo != null) {
            latest = postMultipartCompanyImage("/api/company/logo", logo)
        }
        if (banner != null) {
            latest = postMultipartCompanyImage("/api/company/banner", banner)
        }
        return latest
    }

    private suspend fun postMultipartImage(path: String, image: PickedImagePayload): AdminBranch {
        val response = client.post(url(path)) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminBranchDto>().toBranch(session)
    }

    private suspend fun postMultipartCompanyImage(path: String, image: PickedImagePayload): AdminCompany {
        val response = client.post(url(path)) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminCompanyDto>().toCompany(session)
    }

    override suspend fun listWorkers(): List<AdminWorker> =
        get<List<AdminStaffUserDto>>("/api/workers").map { it.toWorker() }

    override suspend fun getWorker(id: String): AdminWorker =
        get<AdminStaffUserDto>("/api/workers/$id").toWorker()

    override suspend fun createWorker(input: AdminWorkerUpsert): AdminWorker =
        post<AdminStaffUserDto>(
            "/api/workers",
            CreateAdminWorkerRequestDto(
                displayName = input.displayName,
                email = input.email,
                role = input.role.name,
                password = input.password,
                active = input.active,
                branchId = input.branchId,
                sex = input.sex.name,
                address = input.address,
                phone = input.phone,
                docId = input.docId,
                workSchedule = input.workSchedule.map { day ->
                    AdminWorkDayScheduleDto(
                        weekday = day.weekday,
                        blocks = day.blocks.map { b ->
                            AdminWorkTimeBlockDto(startTime = b.startTime, endTime = b.endTime)
                        },
                    )
                },
                serviceIds = input.serviceIds,
            ),
        ).toWorker()

    override suspend fun updateWorker(id: String, input: AdminWorkerUpsert): AdminWorker =
        put<AdminStaffUserDto>(
            "/api/workers/$id",
            UpdateAdminWorkerRequestDto(
                displayName = input.displayName,
                email = input.email,
                role = input.role.name,
                password = input.password,
                active = input.active,
                branchId = input.branchId,
                sex = input.sex.name,
                address = input.address,
                phone = input.phone,
                docId = input.docId,
                workSchedule = input.workSchedule.map { day ->
                    AdminWorkDayScheduleDto(
                        weekday = day.weekday,
                        blocks = day.blocks.map { b ->
                            AdminWorkTimeBlockDto(startTime = b.startTime, endTime = b.endTime)
                        },
                    )
                },
                serviceIds = input.serviceIds,
                inactivationReason = input.inactivationReason,
                inactivationNote = input.inactivationNote,
            ),
        ).toWorker()

    override suspend fun deleteWorker(id: String) {
        deleteNoContent("/api/workers/$id")
    }

    override suspend fun uploadWorkerPhoto(id: String, image: PickedImagePayload): AdminWorker {
        val response = client.post(url("/api/workers/$id/photo")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminStaffUserDto>().toWorker()
    }

    override suspend fun fetchWorkerPhotoBytes(id: String): ByteArray? {
        val response = client.get(url("/api/workers/$id/photo"))
        if (response.status.value == 404) return null
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val bytes = response.body<ByteArray>()
        return bytes.takeIf { it.isNotEmpty() }
    }

    override suspend fun deleteWorkerPhoto(id: String) = deleteNoContent("/api/workers/$id/photo")

    override suspend fun listServices(): List<AdminCatalogService> =
        get<List<AdminServiceDto>>("/api/services").map { it.toCatalog() }

    override suspend fun getService(id: String): AdminCatalogService =
        get<AdminServiceDto>("/api/services/$id").toCatalog()

    override suspend fun createService(input: AdminCatalogServiceUpsert): AdminCatalogService =
        post<AdminServiceDto>(
            "/api/services",
            CreateAdminServiceRequestDto(
                name = input.name,
                type = input.type.name,
                durationMin = input.durationMin,
                active = input.active,
                description = input.description?.trim()?.ifBlank { null },
            ),
        ).toCatalog().let { created ->
            input.image?.let { postCatalogImage("/api/services/${created.id}/image", it) } ?: created
        }

    override suspend fun updateService(id: String, input: AdminCatalogServiceUpsert): AdminCatalogService =
        put<AdminServiceDto>(
            "/api/services/$id",
            UpdateAdminServiceRequestDto(
                name = input.name,
                type = input.type.name,
                durationMin = input.durationMin,
                active = input.active,
                description = input.description?.trim()?.ifBlank { null },
            ),
        ).toCatalog().let { updated ->
            input.image?.let { postCatalogImage("/api/services/$id/image", it) } ?: updated
        }

    override suspend fun deleteService(id: String) {
        deleteNoContent("/api/services/$id")
    }

    override suspend fun listMembershipPlans(): List<AdminMembershipPlanItem> =
        get<List<AdminMembershipPlanDto>>("/api/membership-plans").map { it.toPlan() }

    override suspend fun getMembershipPlan(id: String): AdminMembershipPlanItem =
        get<AdminMembershipPlanDto>("/api/membership-plans/$id").toPlan()

    override suspend fun createMembershipPlan(input: AdminMembershipPlanUpsert): AdminMembershipPlanItem =
        post<AdminMembershipPlanDto>(
            "/api/membership-plans",
            CreateAdminMembershipPlanRequestDto(
                name = input.name,
                billingPeriod = input.billingPeriod.name,
                scheduleType = input.scheduleType.name,
                priceCents = input.priceCents,
                priceUsdCents = input.priceUsdCents,
                active = input.active,
                serviceIds = input.serviceIds,
                reminderLeadDays = input.reminderLeadDays,
            ),
        ).toPlan()

    override suspend fun updateMembershipPlan(id: String, input: AdminMembershipPlanUpsert): AdminMembershipPlanItem =
        put<AdminMembershipPlanDto>(
            "/api/membership-plans/$id",
            UpdateAdminMembershipPlanRequestDto(
                name = input.name,
                billingPeriod = input.billingPeriod.name,
                scheduleType = input.scheduleType.name,
                priceCents = input.priceCents,
                priceUsdCents = input.priceUsdCents,
                active = input.active,
                serviceIds = input.serviceIds,
                reminderLeadDays = input.reminderLeadDays,
            ),
        ).toPlan()

    override suspend fun deleteMembershipPlan(id: String) {
        deleteNoContent("/api/membership-plans/$id")
    }

    override suspend fun listMemberships(): List<AdminMembershipItem> =
        get<List<AdminMembershipDto>>("/api/memberships").map { it.toMembership() }

    override suspend fun getMembership(id: String): AdminMembershipItem =
        get<AdminMembershipDto>("/api/memberships/$id").toMembership()

    override suspend fun listMembershipAccessHistory(membershipId: String): List<AdminMembershipAccessHistoryItem> =
        get<List<AdminMembershipAccessHistoryDto>>("/api/memberships/$membershipId/access-history")
            .map { it.toHistoryItem() }

    override suspend fun createMembership(input: AdminMembershipUpsert): AdminMembershipItem =
        post<AdminMembershipDto>(
            "/api/memberships",
            CreateAdminMembershipRequestDto(
                clientId = input.clientId,
                planId = input.planId,
                status = input.status.name,
                startsAt = input.startsAt,
                endsAt = input.endsAt,
                branchId = input.branchId,
                trainerId = input.trainerId,
                manualReason = input.manualReason,
            ),
        ).toMembership()

    override suspend fun updateMembership(id: String, input: AdminMembershipUpsert): AdminMembershipItem =
        put<AdminMembershipDto>(
            "/api/memberships/$id",
            UpdateAdminMembershipRequestDto(
                clientId = input.clientId,
                planId = input.planId,
                status = input.status.name,
                startsAt = input.startsAt,
                endsAt = input.endsAt,
                branchId = input.branchId,
                trainerId = input.trainerId,
                manualReason = input.manualReason,
            ),
        ).toMembership()

    override suspend fun blockMembership(id: String, reason: String?): AdminMembershipItem =
        post<AdminMembershipDto>(
            "/api/memberships/$id/manual-block",
            ManualMembershipRequestDto(reason = reason),
        ).toMembership()

    override suspend fun releaseMembershipAutomatic(id: String): AdminMembershipItem =
        post<AdminMembershipDto>(
            "/api/memberships/$id/release-automatic",
            ManualMembershipRequestDto(),
        ).toMembership()

    override suspend fun deleteMembership(id: String) {
        deleteNoContent("/api/memberships/$id")
    }

    override suspend fun registerTrainingSession(
        membershipId: String,
        sessionDate: String,
        attendance: AdminTrainingAttendance,
        serviceId: String?,
    ) {
        post<AdminTrainingSessionDto>(
            "/api/memberships/$membershipId/training-sessions",
            CreateAdminTrainingSessionRequestDto(
                sessionDate = sessionDate,
                attendance = attendance.name,
                serviceId = serviceId,
            ),
        )
    }

    override suspend fun listOrders(): List<AdminOrder> =
        get<List<AdminOrderDto>>("/api/orders").map { it.toOrder() }

    override suspend fun getOrder(id: String): AdminOrder =
        get<AdminOrderDto>("/api/orders/$id").toOrder()

    override suspend fun createOrder(input: AdminOrderUpsert): AdminOrder =
        post<AdminOrderDto>(
            "/api/orders",
            CreateAdminOrderRequestDto(
                clientId = input.clientId,
                status = input.status.name,
                lines = listOf(
                    CreateAdminOrderLineDto(
                        qty = 1,
                        unitPriceCents = input.totalAmountCents,
                        description = input.itemsLabel.trim().ifBlank { null },
                    ),
                ),
            ),
        ).toOrder()

    override suspend fun updateOrder(id: String, input: AdminOrderUpsert): AdminOrder =
        put<AdminOrderDto>(
            "/api/orders/$id",
            UpdateAdminOrderRequestDto(
                clientId = input.clientId,
                status = input.status.name,
                lines = listOf(
                    CreateAdminOrderLineDto(
                        qty = 1,
                        unitPriceCents = input.totalAmountCents,
                        description = input.itemsLabel.trim().ifBlank { null },
                    ),
                ),
            ),
        ).toOrder()

    override suspend fun deleteOrder(id: String) {
        deleteNoContent("/api/orders/$id")
    }

    override suspend fun listPayments(): List<AdminPayment> =
        get<List<AdminPaymentDto>>("/api/payments").map { it.toPayment() }

    override suspend fun getPayment(id: String): AdminPayment =
        get<AdminPaymentDto>("/api/payments/$id").toPayment()

    override suspend fun createPayment(input: AdminPaymentUpsert): AdminPayment =
        post<AdminPaymentDto>(
            "/api/payments",
            CreateAdminPaymentRequestDto(
                orderId = input.orderId,
                clientId = input.clientId,
                amountCents = input.amountCents,
                currency = input.currency,
                method = input.method.name,
                status = input.status.name,
                notes = input.notes,
                payerPhone = input.payerPhone,
                paidAt = input.paidAt,
                planId = input.planId,
                branchId = input.branchId,
                trainerId = input.trainerId,
            ),
        ).toPayment()

    override suspend fun collectPayments(input: AdminPaymentCollect): List<AdminPayment> =
        post<CollectAdminPaymentResponseDto>(
            "/api/payments/collect",
            CollectAdminPaymentRequestDto(
                currency = input.currency,
                discount = input.discount?.toCollectDiscountDto(),
                targets = input.targets.map { t ->
                    CollectAdminPaymentTargetDto(
                        orderId = t.orderId,
                        clientId = t.clientId,
                        membershipOrderId = t.membershipOrderId,
                        amountCents = t.amountCents,
                        planId = t.planId,
                        branchId = t.branchId,
                        trainerId = t.trainerId,
                        discount = t.discount?.toCollectDiscountDto(),
                    )
                },
                lines = input.lines.map { l ->
                    CollectAdminPaymentLineDto(
                        method = l.method.name,
                        amountCents = l.amountCents,
                        foreignUsdCents = l.foreignUsdCents,
                        payerPhone = l.payerPhone,
                        notes = l.notes,
                    )
                },
                paidAt = input.paidAt,
                changeGivenCents = input.changeGivenCents.takeIf { it > 0 },
                changeGivenUsdCents = input.changeGivenUsdCents.takeIf { it > 0 },
            ),
        ).payments.map { it.toPayment() }

    override suspend fun updatePayment(id: String, input: AdminPaymentUpsert): AdminPayment =
        put<AdminPaymentDto>(
            "/api/payments/$id",
            UpdateAdminPaymentRequestDto(
                amountCents = input.amountCents,
                currency = input.currency,
                method = input.method.name,
                status = input.status.name,
                notes = input.notes,
                payerPhone = input.payerPhone,
                paidAt = input.paidAt,
            ),
        ).toPayment()

    override suspend fun stageMembershipOrderProof(image: PickedImagePayload): String {
        val response = client.post(url("/api/membership-orders/approval-proof")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<Map<String, String>>()["path"]
            ?: throw ApiException(500, "El servidor no devolvió la ruta del comprobante")
    }

    override suspend fun uploadPaymentProof(id: String, image: PickedImagePayload): AdminPayment {
        val response = client.post(url("/api/payments/$id/proof")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<AdminPaymentDto>().toPayment()
    }

    override suspend fun deletePayment(id: String) {
        deleteNoContent("/api/payments/$id")
    }

    override suspend fun listPromotions(): List<AdminPromotion> =
        get<List<MarketingPromotionDto>>("/api/marketing/promotions").map { it.toPromotion() }

    override suspend fun getPromotion(id: String): AdminPromotion =
        get<MarketingPromotionDto>("/api/marketing/promotions/$id").toPromotion()

    override suspend fun createPromotion(input: AdminPromotionUpsert): AdminPromotion {
        val response = client.post(url("/api/marketing/promotions")) {
            setBody(
                MultiPartFormDataContent(
                    formData {
                        append("title", input.title.trim())
                        append("displayType", input.displayType)
                        append("channel", input.channel.name)
                        append("active", input.active.toString())
                        append("sortOrder", input.sortOrder.toString())
                        input.details?.takeIf { it.isNotBlank() }?.let { append("details", it) }
                        input.videoUrl?.takeIf { it.isNotBlank() }?.let { append("videoUrl", it.trim()) }
                        if (input.channel.includesApp()) {
                            dateToInstant(input.startsAt)?.let { append("startsAt", it) }
                            endDateToInstant(input.endsAt)?.let { append("endsAt", it) }
                        }
                        if (input.channel.includesWhatsApp()) {
                            input.scheduledAt?.takeIf { it.isNotBlank() }?.let { append("scheduledAt", it) }
                        }
                        input.banner?.let { appendUploadFile("files", it) }
                    },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val created = response.body<MarketingPromotionDto>().toPromotion()
        val banner = input.banner ?: return created
        if (created.slides.isNotEmpty()) return created
        // Create accepted without files in some cases — force banner upload.
        return replacePromotionBanner(created.id, banner)
    }

    override suspend fun updatePromotion(id: String, input: AdminPromotionUpsert): AdminPromotion {
        val banner = input.banner
        val uploaded = if (banner != null) replacePromotionBanner(id, banner) else null
        val typedVideo = input.videoUrl?.trim()?.ifBlank { null }
        val video = typedVideo
            ?: uploaded?.videoUrl?.takeIf { uploaded.displayType == "VIDEO" }
        val display = if (uploaded?.displayType == "VIDEO") "VIDEO" else input.displayType
        return put<MarketingPromotionDto>(
            "/api/marketing/promotions/$id",
            UpdateMarketingPromotionRequestDto(
                title = input.title.trim(),
                details = input.details,
                displayType = display,
                channel = input.channel.name,
                active = input.active,
                sortOrder = input.sortOrder,
                startsAt = if (input.channel.includesApp()) dateToInstant(input.startsAt) else null,
                endsAt = if (input.channel.includesApp()) endDateToInstant(input.endsAt) else null,
                scheduledAt = if (input.channel.includesWhatsApp()) input.scheduledAt?.takeIf { it.isNotBlank() } else null,
                videoUrl = video,
            ),
        ).toPromotion()
    }

    override suspend fun deletePromotion(id: String) {
        deleteNoContent("/api/marketing/promotions/$id")
    }

    override suspend fun sessionReport(filters: AdminReportFilters): AdminSessionReport {
        val dto = get<AdminSessionReportDto>("/api/reports/sessions${reportQuery(filters)}")
        return AdminSessionReport(
            sessions = dto.sessions,
            clients = dto.clients,
            staff = dto.staff,
            accessVisits = dto.accessVisits,
            currency = dto.currency,
            rows = dto.rows.map {
                AdminSessionReportRow(
                    date = it.date,
                    occurredAt = it.occurredAt,
                    subjectType = it.subjectType,
                    subjectTypeLabel = it.subjectTypeLabel,
                    subjectId = it.subjectId,
                    subjectName = it.subjectName,
                    source = it.source,
                    sourceLabel = it.sourceLabel,
                    scheduleTitle = it.scheduleTitle,
                    trainerName = it.trainerName,
                )
            },
        )
    }

    override suspend fun membershipReport(filters: AdminReportFilters): AdminMembershipReport {
        val dto = get<AdminMembershipReportDto>("/api/reports/memberships${reportQuery(filters)}")
        return AdminMembershipReport(
            memberships = dto.memberships,
            active = dto.active,
            incomeCents = dto.incomeCents,
            trainers = dto.trainers,
            currency = dto.currency,
            rows = dto.rows.map {
                AdminMembershipReportRow(
                    membershipId = it.membershipId,
                    startsAt = it.startsAt,
                    endsAt = it.endsAt,
                    branchId = it.branchId,
                    branchName = it.branchName,
                    trainerId = it.trainerId,
                    trainerName = it.trainerName,
                    clientName = it.clientName,
                    planName = it.planName,
                    status = it.status,
                    statusLabel = it.statusLabel,
                    method = it.method,
                    methodLabel = it.methodLabel,
                    priceCents = it.priceCents,
                    currency = it.currency,
                    foreignUsdCents = it.foreignUsdCents,
                    foreignEurCents = it.foreignEurCents,
                    paidCents = it.paidCents,
                    discountCents = it.discountCents,
                    pendingBsCents = it.pendingBsCents,
                    pendingUsdCents = it.pendingUsdCents,
                    discountUsdCents = it.discountUsdCents,
                    changeGivenCents = it.changeGivenCents,
                )
            },
            totalsByMethod = mapPaymentMethodTotals(dto.totalsByMethod),
            discountCents = dto.discountCents,
            pendingBsCents = dto.pendingBsCents,
            pendingUsdCents = dto.pendingUsdCents,
        )
    }

    override suspend fun enrollmentReport(filters: AdminReportFilters): AdminEnrollmentReport {
        val dto = get<AdminEnrollmentReportDto>("/api/reports/enrollments${reportQuery(filters)}")
        return AdminEnrollmentReport(
            enrollments = dto.enrollments,
            clients = dto.clients,
            trainers = dto.trainers,
            plans = dto.plans,
            rows = dto.rows.map {
                AdminEnrollmentReportRow(
                    enrolledAt = it.enrolledAt,
                    clientId = it.clientId,
                    clientName = it.clientName,
                    planId = it.planId,
                    planName = it.planName,
                    trainerId = it.trainerId,
                    trainerName = it.trainerName,
                    status = it.status,
                    statusLabel = it.statusLabel,
                )
            },
        )
    }

    override suspend fun cashReconciliationReport(filters: AdminReportFilters): AdminCashReconciliationReport {
        val day = filters.from ?: filters.to ?: todayIsoDate()
        val query = buildString {
            append("?date=$day")
            filters.branchId?.takeIf { it.isNotBlank() }?.let { append("&branchId=$it") }
        }
        val dto = get<AdminCashReconciliationReportDto>("/api/reports/cash-reconciliation$query")
        return AdminCashReconciliationReport(
            date = dto.date,
            currency = dto.currency,
            totalInCents = dto.totalInCents,
            totalOutCents = dto.totalOutCents,
            netCents = dto.netCents,
            rows = dto.rows.map {
                AdminCashReconciliationRow(
                    timeLabel = it.timeLabel,
                    sourceType = it.sourceType,
                    sourceLabel = it.sourceLabel,
                    clientName = it.clientName,
                    method = it.method,
                    methodLabel = it.methodLabel,
                    amountCents = it.amountCents,
                    currency = it.currency,
                    detail = it.detail,
                    foreignUsdCents = it.foreignUsdCents,
                    foreignEurCents = it.foreignEurCents,
                    methodAmounts = it.methodAmounts.map { m ->
                        AdminCashMethodAmount(
                            method = m.method,
                            methodLabel = m.methodLabel,
                            amountCents = m.amountCents,
                            foreignUsdCents = m.foreignUsdCents,
                            reference = m.reference,
                        )
                    }.ifEmpty {
                        listOf(
                            AdminCashMethodAmount(
                                method = it.method,
                                methodLabel = it.methodLabel,
                                amountCents = it.amountCents,
                                foreignUsdCents = it.foreignUsdCents,
                                reference = it.detail.takeIf { d ->
                                    it.method.equals("MOBILE_PAYMENT", ignoreCase = true) &&
                                        d.isNotBlank() &&
                                        !d.startsWith("Orden #") &&
                                        d != "Cobro"
                                },
                            )
                        )
                    },
                    changeGivenCents = it.changeGivenCents,
                    paidDateLabel = it.paidDateLabel,
                    registeredLabel = it.registeredLabel,
                )
            },
            totalsByMethod = mapPaymentMethodTotals(dto.totalsByMethod),
        )
    }

    override suspend fun salesReport(filters: AdminReportFilters): AdminSalesReport {
        val dto = get<AdminSalesReportDto>("/api/reports/sales${reportQuery(filters)}")
        return AdminSalesReport(
            sales = dto.sales,
            paid = dto.paid,
            pending = dto.pending,
            incomeCents = dto.incomeCents,
            changeGivenCents = dto.changeGivenCents,
            currency = dto.currency,
            pendingBsCents = dto.pendingBsCents,
            pendingUsdCents = dto.pendingUsdCents,
            discountCents = dto.discountCents,
            rows = dto.rows.map {
                AdminSalesReportRow(
                    saleDate = it.saleDate,
                    saleNumber = it.saleNumber,
                    clientId = it.clientId,
                    customerName = it.customerName,
                    branchId = it.branchId,
                    branchName = it.branchName,
                    trainerId = it.trainerId,
                    trainerName = it.trainerName,
                    method = it.method,
                    methodLabel = it.methodLabel,
                    origin = it.origin,
                    originLabel = it.originLabel,
                    status = it.status,
                    statusLabel = it.statusLabel,
                    itemsSummary = it.itemsSummary,
                    totalCents = it.totalCents,
                    amountPaidCents = it.amountPaidCents,
                    changeGivenCents = it.changeGivenCents,
                    currency = it.currency,
                    foreignUsdCents = it.foreignUsdCents,
                    foreignEurCents = it.foreignEurCents,
                    productName = it.productName,
                    productId = it.productId,
                    qty = it.qty,
                    stockQty = it.stockQty,
                    pendingBsCents = it.pendingBsCents,
                    pendingUsdCents = it.pendingUsdCents,
                    paymentsSummary = it.paymentsSummary,
                    discountCents = it.discountCents,
                    discountUsdCents = it.discountUsdCents,
                )
            },
            totalsByMethod = mapPaymentMethodTotals(dto.totalsByMethod),
        )
    }

    override suspend fun inventoryReport(filters: AdminReportFilters): AdminInventoryReport {
        val dto = get<AdminInventoryReportDto>("/api/reports/inventory${reportQuery(filters)}")
        return AdminInventoryReport(
            products = dto.products,
            units = dto.units,
            low = dto.low,
            out = dto.out,
            currency = dto.currency,
            rows = dto.rows.map {
                AdminInventoryReportRow(
                    productId = it.productId,
                    name = it.name,
                    categoryId = it.categoryId,
                    categoryName = it.categoryName,
                    stockQty = it.stockQty,
                    minStockQty = it.minStockQty,
                    stockLevel = it.stockLevel,
                    stockLevelLabel = it.stockLevelLabel,
                    priceCents = it.priceCents,
                    priceUsdCents = it.priceUsdCents,
                    currency = it.currency,
                    description = it.description,
                    active = it.active,
                    activeLabel = it.activeLabel,
                )
            },
        )
    }

    private fun mapPaymentMethodTotals(
        totals: List<org.gymly.api.dto.AdminPaymentMethodTotalDto>,
    ): List<org.gymly.model.AdminPaymentMethodTotal> =
        totals.map {
            org.gymly.model.AdminPaymentMethodTotal(
                method = it.method,
                methodLabel = it.methodLabel,
                totalCents = it.totalCents,
                count = it.count,
                foreignUsdCents = it.foreignUsdCents,
                foreignEurCents = it.foreignEurCents,
            )
        }

    override suspend fun currentExchangeRate(): org.gymly.model.AdminExchangeRateQuote =
        get<org.gymly.api.dto.AdminExchangeRateQuoteDto>("/api/exchange-rates/current").toExchangeQuote()

    override suspend fun exchangeRateSettings(): org.gymly.model.AdminExchangeRateSettings =
        get<org.gymly.api.dto.AdminExchangeRateSettingsDto>("/api/exchange-rates/settings").toExchangeSettings()

    override suspend fun updateExchangeRateSettings(
        input: org.gymly.model.AdminExchangeRateSettingsUpsert,
    ): org.gymly.model.AdminExchangeRateSettings =
        put<org.gymly.api.dto.AdminExchangeRateSettingsDto>(
            "/api/exchange-rates/settings",
            org.gymly.api.dto.UpdateAdminExchangeRateSettingsDto(
                manualOverrideEnabled = input.manualOverrideEnabled,
                manualEurRate = input.manualEurRate,
                manualUsdRate = input.manualUsdRate,
                manualCnyRate = input.manualCnyRate,
                manualTryRate = input.manualTryRate,
                manualRubRate = input.manualRubRate,
                manualEffectiveDate = input.manualEffectiveDate,
                divisasUsesEurRate = input.divisasUsesEurRate,
            ),
        ).toExchangeSettings()

    override suspend fun registerManualExchangeRate(
        effectiveDate: String,
        eurRate: Double,
        usdRate: Double,
    ): org.gymly.model.AdminExchangeRateSettings =
        post<org.gymly.api.dto.AdminExchangeRateSettingsDto>(
            "/api/exchange-rates/manual",
            org.gymly.api.dto.ManualExchangeRateRequestDto(
                effectiveDate = effectiveDate,
                eurRate = eurRate,
                usdRate = usdRate,
            ),
        ).toExchangeSettings()

    override suspend fun refreshExchangeRates(): org.gymly.model.AdminExchangeRateQuote =
        post<org.gymly.api.dto.AdminExchangeRateQuoteDto>("/api/exchange-rates/refresh", emptyMap<String, String>()).toExchangeQuote()

    override suspend fun convertDivisas(usdCents: Long): org.gymly.model.AdminDivisasConversion =
        post<org.gymly.api.dto.AdminDivisasConversionDto>(
            "/api/exchange-rates/convert-divisas",
            org.gymly.api.dto.ConvertDivisasRequestDto(usdCents = usdCents),
        ).toDivisasConversion()

    override suspend fun listClientAccounts(): List<org.gymly.model.AdminClientAccountSummary> =
        get<List<org.gymly.api.dto.AdminClientAccountSummaryDto>>("/api/client-accounts").map { it.toClientAccountSummary() }

    override suspend fun clientAccountStatement(clientId: String): org.gymly.model.AdminClientAccountStatement =
        get<org.gymly.api.dto.AdminClientAccountStatementDto>("/api/client-accounts/clients/$clientId/statement")
            .toClientAccountStatement()

    override suspend fun applyClientAccountCredit(
        clientId: String,
        input: org.gymly.model.AdminClientAccountApplyCredit,
    ): org.gymly.model.AdminClientAccountApplyCreditResult =
        post<org.gymly.api.dto.AdminClientAccountApplyCreditResultDto>(
            "/api/client-accounts/clients/$clientId/apply-credit",
            org.gymly.api.dto.AdminClientAccountApplyCreditRequestDto(
                membershipOrderId = input.membershipOrderId,
                salesOrderId = input.salesOrderId,
                amountCents = input.amountCents,
            ),
        ).toClientAccountApplyCreditResult()

    override suspend fun depositToClientWallets(
        input: org.gymly.model.AdminClientWalletDepositBatch,
    ): org.gymly.model.AdminClientWalletDepositResult =
        post<org.gymly.api.dto.AdminClientWalletDepositBatchResultDto>(
            "/api/client-accounts/deposit-batch",
            org.gymly.api.dto.AdminClientWalletDepositBatchRequestDto(
                deposits = input.deposits.map {
                    org.gymly.api.dto.AdminClientWalletDepositItemDto(
                        clientId = it.clientId,
                        shareCents = it.shareCents,
                    )
                },
                paymentTotalCents = input.paymentTotalCents,
                description = input.description,
            ),
        ).let { dto ->
            org.gymly.model.AdminClientWalletDepositResult(
                clientCount = dto.clientCount,
                paymentTotalCents = dto.paymentTotalCents,
            )
        }

    override suspend fun exportReport(
        kind: AdminReportKind,
        format: AdminReportExportFormat,
        filters: AdminReportFilters,
    ): AdminReportFile {
        val path = buildString {
            append("/api/reports/export?kind=${kind.name}&format=${format.apiValue}")
            append(reportQuery(filters).removePrefix("?").let { if (it.isEmpty()) "" else "&$it" })
        }
        val response = client.get(url(path))
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        val bytes = response.body<ByteArray>()
        val disposition = response.headers[HttpHeaders.ContentDisposition].orEmpty()
        val fileName = parseContentDispositionFileName(
            disposition,
            "reporte-${kind.name.lowercase().replace('_', '-')}.${format.extension}",
        )
        val mime = response.headers[HttpHeaders.ContentType]?.substringBefore(';')?.trim()
            ?: format.mimeType
        return AdminReportFile(fileName = fileName, mimeType = mime, bytes = bytes)
    }

    private fun reportQuery(filters: AdminReportFilters): String {
        val parts = mutableListOf<String>()
        filters.branchId?.takeIf { it.isNotBlank() }?.let { parts += "branchId=$it" }
        filters.trainerId?.takeIf { it.isNotBlank() }?.let { parts += "trainerId=$it" }
        filters.clientId?.takeIf { it.isNotBlank() }?.let { parts += "clientId=$it" }
        filters.staffId?.takeIf { it.isNotBlank() }?.let { parts += "staffId=$it" }
        filters.subjectType?.takeIf { it.isNotBlank() }?.let { parts += "subjectType=$it" }
        filters.clientStatus?.takeIf { it.isNotBlank() }?.let { parts += "clientStatus=$it" }
        filters.membership?.takeIf { it.isNotBlank() }?.let { parts += "membership=$it" }
        filters.status?.takeIf { it.isNotBlank() }?.let { parts += "status=$it" }
        filters.method?.takeIf { it.isNotBlank() }?.let { parts += "method=$it" }
        filters.productId?.takeIf { it.isNotBlank() }?.let { parts += "productId=$it" }
        filters.planId?.takeIf { it.isNotBlank() }?.let { parts += "planId=$it" }
        filters.categoryId?.takeIf { it.isNotBlank() }?.let { parts += "categoryId=$it" }
        filters.from?.takeIf { it.isNotBlank() }?.let { parts += "from=$it" }
        filters.to?.takeIf { it.isNotBlank() }?.let { parts += "to=$it" }
        return if (parts.isEmpty()) "" else "?" + parts.joinToString("&")
    }

    override suspend fun replacePromotionBanner(id: String, image: PickedImagePayload): AdminPromotion {
        val response = client.post(url("/api/marketing/promotions/$id/banner")) {
            setBody(
                MultiPartFormDataContent(
                    formData { appendUploadFile("file", image) },
                ),
            )
        }
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body<MarketingPromotionDto>().toPromotion()
    }

    override suspend fun listFor(route: AdminRoute): List<AdminListRow> = when (route) {
        AdminRoute.Dashboard, AdminRoute.BulkSignup, AdminRoute.Reports, AdminRoute.Settings, AdminRoute.Profile,
        AdminRoute.TermsMonitoring -> emptyList()
        AdminRoute.Clients -> listClients().map { c ->
            val contact = listOfNotNull(c.email, c.phone).joinToString(" · ")
            AdminListRow(
                id = c.id,
                title = c.fullName,
                subtitle = listOfNotNull(contact.takeIf { it.isNotBlank() }, c.status.name).joinToString(" · "),
                badge = if (c.portalEnabled) "Portal activo" else null,
            )
        }
        AdminRoute.Workers -> listWorkers().map { u ->
            AdminListRow(
                id = u.id,
                title = u.displayName,
                subtitle = listOfNotNull(u.email, u.role.labelEs(), if (u.active) "Activo" else "Inactivo")
                    .joinToString(" · "),
            )
        }
        AdminRoute.Services -> listServices().map { s ->
            val duration = s.durationMin?.let { "$it min" } ?: "—"
            AdminListRow(
                id = s.id,
                title = s.name,
                subtitle = "${s.type.labelEs()} · $duration · ${if (s.active) "ACTIVO" else "INACTIVO"}",
            )
        }
        AdminRoute.MembershipPlans -> listMembershipPlans().map { p ->
            AdminListRow(
                id = p.id,
                title = p.name,
                subtitle = "${p.billingPeriod.labelEs()} · ${p.scheduleType.labelEs()} · ${formatMoney(p.priceCents.toInt(), org.gymly.util.GymlyCurrency.CODE)} · ${if (p.active) "ACTIVO" else "INACTIVO"}",
            )
        }
        AdminRoute.MembershipOrders -> listMembershipOrders().map { o ->
            AdminListRow(
                id = o.id,
                title = "${o.displayNumber()} · ${o.clientName}",
                subtitle = "${o.planName} · ${o.statusLabel} · ${formatMoney(o.amountCents.toInt(), o.currency)}",
            )
        }
        AdminRoute.Memberships -> listMemberships().map { m ->
            AdminListRow(
                id = m.id,
                title = "${m.clientName} → ${m.planName}",
                subtitle = buildString {
                    append(m.status.labelEs())
                    append(" · desde ")
                    append(m.startsAt)
                    m.endsAt?.let { append(" · hasta $it") }
                },
            )
        }
        AdminRoute.ClientAccounts -> listClientAccounts()
            .filter { it.balanceCents > 0 }
            .map { a ->
                AdminListRow(
                    id = a.clientId,
                    title = a.clientName,
                    subtitle = "Saldo ${formatMoney(a.balanceCents.toInt(), a.currency)}",
                )
            }
        AdminRoute.Orders -> listOrders().map { o ->
            AdminListRow(
                id = o.id,
                title = "${o.displayNumber()} · ${o.clientName}",
                subtitle = "${o.itemsSummary()} · ${formatMoney(o.totalAmountCents.toInt(), org.gymly.util.GymlyCurrency.CODE)} · ${o.status.labelEs()}",
            )
        }
        AdminRoute.Payments -> listPayments().map { p ->
            AdminListRow(
                id = p.id,
                title = "${p.clientName} · ${formatMoney(p.amountCents.toInt(), p.currency)}",
                subtitle = "${p.method.labelEs()} · ${p.origin.labelEs()} · ${p.status.labelEs()}",
            )
        }
        AdminRoute.Marketing -> listPromotions().map { m ->
            AdminListRow(
                id = m.id,
                title = m.title,
                subtitle = "${m.dateRangeLabel()} · ${m.status().labelEs()}",
            )
        }
        AdminRoute.Products -> listProducts().map { p ->
            AdminListRow(
                id = p.id,
                title = p.name,
                subtitle = listOfNotNull(p.branchName, p.categoryLabel, productPriceLabel(p.priceCents, p.currency, p.priceUsdCents))
                    .joinToString(" · "),
                badge = if (p.active) "Activo" else "Inactivo",
            )
        }
        AdminRoute.StoreSales -> listStoreSales().map { s ->
            AdminListRow(
                id = s.id,
                title = "#${s.saleNumber} · ${s.customerName}",
                subtitle = listOfNotNull(
                    s.itemsSummary.takeIf { it.isNotBlank() },
                    s.branchName,
                    formatMoney(s.totalCents.toInt(), s.currency),
                    s.statusLabel,
                ).joinToString(" · "),
            )
        }
        AdminRoute.Schedules -> listSchedules().map { s ->
            AdminListRow(
                id = s.id,
                title = s.slotLabel(),
                subtitle = listOfNotNull(s.trainerName, s.title).joinToString(" — "),
            )
        }
        AdminRoute.Bookings -> listBookings().map { b ->
            AdminListRow(
                id = b.id,
                title = "${b.clientName} · ${b.franjaLabel()}",
                subtitle = "${b.sessionDate} · ${b.status.labelEs()}",
            )
        }
    }

    private suspend fun clientNameMap(): Map<String, String> =
        get<List<AdminClientDto>>("/api/clients").associate { c ->
            c.id to "${c.firstName} ${c.lastName}".trim()
        }

    override fun subtitleFor(route: AdminRoute): String = adminSubtitleFor(route)

    override fun logout() {
        session.clearAuth()
        AuthPersistence.clear(StoredAuthKind.ADMIN)
        SessionActivity.clear()
    }

    override suspend fun listStaffAuditEvents(
        days: Int?,
        staffId: String?,
        moduleCode: String?,
        eventType: AdminStaffAuditEventType?,
    ): List<AdminStaffAuditEvent> {
        val query = staffAuditQuery(days, staffId, moduleCode, eventType)
        return get<List<AdminStaffAuditEventDto>>("/api/staff-audit/events$query").map { it.toAuditEvent() }
    }

    override suspend fun exportStaffAuditCsv(
        days: Int?,
        staffId: String?,
        moduleCode: String?,
        eventType: AdminStaffAuditEventType?,
    ): ByteArray {
        val query = staffAuditQuery(days, staffId, moduleCode, eventType)
        val response = client.get(url("/api/staff-audit/events.csv$query"))
        if (!response.status.isSuccess()) {
            throw ApiException(response.status.value, response.bodyAsText().take(2000))
        }
        return response.body()
    }

    override suspend fun purgeStaffAudit(days: Int?): Pair<Int, String> {
        val q = days?.takeIf { it > 0 }?.let { "?days=$it" } ?: ""
        val res = post<org.gymly.api.dto.AdminStaffAuditPurgeResponseDto>(
            "/api/staff-audit/purge$q",
            emptyMap<String, String>(),
        )
        return res.removed to res.message
    }

    private fun staffAuditQuery(
        days: Int?,
        staffId: String?,
        moduleCode: String?,
        eventType: AdminStaffAuditEventType?,
    ): String {
        val params = buildList {
            days?.let { add("days=$it") }
            staffId?.takeIf { it.isNotBlank() }?.let { add("staffId=$it") }
            moduleCode?.takeIf { it.isNotBlank() }?.let { add("moduleCode=$it") }
            eventType?.let { add("eventType=${it.name}") }
        }
        return if (params.isEmpty()) "" else "?${params.joinToString("&")}"
    }

    override suspend fun recordStaffAuditEvent(input: AdminStaffAuditRecord) {
        runCatching {
            post<AdminStaffAuditEventDto>(
                "/api/staff-audit/events",
                RecordAdminStaffAuditRequestDto(
                    eventType = input.eventType.name,
                    moduleCode = input.moduleCode,
                    moduleLabel = input.moduleLabel,
                    detail = input.detail,
                    sessionId = input.sessionId,
                    durationSeconds = input.durationSeconds,
                ),
            )
        }
    }

    private fun AdminStaffAuditEventDto.toAuditEvent() = AdminStaffAuditEvent(
        id = id,
        staffId = staffId,
        staffName = staffName,
        staffEmail = staffEmail,
        eventType = AdminStaffAuditEventType.fromApi(eventType),
        eventLabel = eventLabel,
        moduleCode = moduleCode,
        moduleLabel = moduleLabel,
        detail = detail,
        sessionId = sessionId,
        durationSeconds = durationSeconds,
        entityType = entityType,
        entityId = entityId,
        occurredAt = occurredAt,
    )
}

private fun AdminScheduleDto.toSchedule() = AdminScheduleSlot(
    id = id,
    weekday = weekday,
    startTime = startTime,
    endTime = endTime,
    title = title,
    capacity = capacity,
    kind = org.gymly.model.AdminScheduleKind.fromApi(kind),
    trainerId = trainerId,
    trainerName = trainerName,
    serviceId = serviceId,
    serviceName = serviceName,
    serviceType = serviceType?.let { org.gymly.model.AdminServiceType.fromApi(it) },
    shift = shift,
    shiftLabel = shiftLabel,
    weekStart = weekStart,
    createdAt = createdAt,
    trainerAbsent = trainerAbsent,
)

private fun AdminVisitDto.toVisit() = AdminVisitItem(
    id = id,
    clientId = clientId,
    staffId = staffId,
    clientName = clientName,
    staffName = staffName,
    visitDate = visitDate,
    occurredAt = occurredAt,
    source = org.gymly.model.AdminVisitSource.fromApi(source),
    scheduleId = scheduleId,
    scheduleTitle = scheduleTitle,
    trainerId = trainerId,
    trainerName = trainerName,
    bookingId = bookingId,
    notes = notes,
    createdAt = createdAt,
)

private fun AdminBranchDto.toBranch(session: PortalSession) = AdminBranch(
    id = id,
    name = name,
    address = address,
    ownerId = ownerId,
    ownerName = ownerName,
    hasLogo = hasLogo,
    hasBanner = hasBanner,
    logoUrl = logoUrl?.let { resolveApiUrl(session, it) },
    bannerUrl = bannerUrl?.let { resolveApiUrl(session, it) },
    bannerThumbUrl = bannerThumbUrl?.let { resolveApiUrl(session, it) },
    createdAt = createdAt,
)

private fun AdminCompanyDto.toCompany(session: PortalSession) = AdminCompany(
    id = id,
    name = name,
    address = address,
    taxId = taxId,
    hasLogo = hasLogo,
    hasBanner = hasBanner,
    logoUrl = logoUrl?.let { resolveApiUrl(session, it) },
    bannerUrl = bannerUrl?.let { resolveApiUrl(session, it) },
    bannerThumbUrl = bannerThumbUrl?.let { resolveApiUrl(session, it) },
    brandColor = brandColor,
    timezone = timezone.ifBlank { "America/Caracas" },
    loginShowClients = loginShowClients,
    loginShowTrainers = loginShowTrainers,
    loginShowOnTime = loginShowOnTime,
    termsMonitoringEnabled = termsMonitoringEnabled,
    termsMonitoringAvailable = termsMonitoringAvailable,
    termsNoticeCooldownDays = termsNoticeCooldownDays,
    representatives = representatives.map {
        AdminCompanyRepresentative(
            id = it.id,
            name = it.name,
            title = it.title,
            docId = it.docId,
            staffId = it.staffId,
            staffName = it.staffName,
            sortOrder = it.sortOrder,
        )
    },
    createdAt = createdAt,
    operatingHours = operatingHours.map { day ->
        AdminWorkDaySchedule(
            weekday = day.weekday,
            blocks = day.blocks.map { b ->
                AdminWorkTimeBlock(startTime = b.startTime, endTime = b.endTime)
            },
        )
    },
)

private fun AdminSettingsUserDto.toSettingsUser() = AdminSettingsUser(
    id = id,
    type = AdminSettingsUserType.fromApi(type),
    displayName = displayName,
    email = email,
    staffRole = staffRole?.let { AdminStaffRole.fromApi(it) },
    roleLabel = roleLabel,
    branchId = branchId,
    branchName = branchName,
    status = AdminSettingsUserStatus.fromApi(status),
    createdAt = createdAt,
)

private fun AdminSettingsRoleDto.toSettingsRole() = AdminSettingsRole(
    id = id,
    name = name,
    permissions = permissions.mapNotNull { AdminSettingsPermissionModule.fromApi(it) }.toSet(),
    clients = clients,
    workers = workers,
    payments = payments,
    marketing = marketing,
    store = store,
    settings = settings,
    membershipOverride = membershipOverride,
    createdAt = createdAt,
)

private fun AdminNotificationItemDto.toModel() = AdminNotificationItem(
    id = id,
    title = title,
    body = body,
    read = read,
    createdAt = createdAt,
    kind = kind,
    refType = refType,
    refId = refId,
)

private fun AdminApprovalRequestDto.toModel() = AdminApprovalRequest(
    id = id,
    type = type,
    status = status,
    summary = summary,
    payloadJson = payloadJson,
    requestedBy = requestedBy,
    requestedByName = requestedByName,
    reviewedBy = reviewedBy,
    reviewedByName = reviewedByName,
    reviewNote = reviewNote,
    createdAt = createdAt,
    reviewedAt = reviewedAt,
)

private fun AdminSettingsMailDto.toSettingsMail() = AdminSettingsMail(
    id = id,
    host = host,
    port = port,
    username = username,
    fromAddress = fromAddress,
    securityMode = AdminSmtpSecurityMode.fromApi(securityMode),
    useTls = useTls,
    passwordConfigured = passwordConfigured,
    createdAt = createdAt,
)

private fun org.gymly.api.dto.AdminSettingsWhatsAppDto.toSettingsWhatsApp() = org.gymly.model.AdminSettingsWhatsApp(
    id = id,
    enabled = enabled,
    apiBaseUrl = apiBaseUrl,
    apiVersion = apiVersion,
    phoneNumberId = phoneNumberId,
    accessTokenConfigured = accessTokenConfigured,
    templateName = templateName,
    templateLanguage = templateLanguage,
    templateWelcome = templateWelcome,
    templatePaymentReceived = templatePaymentReceived,
    templatePaymentPending = templatePaymentPending,
    templateMembershipExpiring = templateMembershipExpiring,
    templateMarketing = templateMarketing,
    templateTermsNotice = templateTermsNotice,
    templateTermsNoticeApproved = templateTermsNoticeApproved,
    sendHour = sendHour,
    saturdayEnabled = saturdayEnabled,
    sundayEnabled = sundayEnabled,
    simulateOnly = simulateOnly,
    createdAt = createdAt,
    updatedAt = updatedAt,
)

private fun AdminSettingsPaymentDto.toSettingsPayment() = AdminSettingsPayment(
    id = id,
    paypalEnabled = paypalEnabled,
    paypalClientId = paypalClientId,
    paypalSecret = paypalSecret,
    paypalMode = AdminPaypalMode.fromApi(paypalMode),
    stripeEnabled = stripeEnabled,
    stripePublicKey = stripePublicKey,
    stripeSecretKey = stripeSecretKey,
    createdAt = createdAt,
)

private fun AdminPaymentMethodsBundleDto.toPaymentMethodsBundle(session: PortalSession) = AdminPaymentMethodsBundle(
    methods = methods.map { it.toPaymentMethodType(session) },
    gateways = (gateways ?: AdminSettingsPaymentDto()).toSettingsPayment(),
)

private fun AdminPaymentMethodTypeDto.toPaymentMethodType(session: PortalSession) = AdminPaymentMethodType(
    id = id,
    code = code,
    title = title,
    description = description,
    imageUrl = imageUrl?.let { resolveApiUrl(session, it) },
    enabled = enabled,
    sortOrder = sortOrder,
    requiresPhone = requiresPhone,
    requiresReference = requiresReference,
    requiresProof = requiresProof,
    autoApprove = autoApprove,
    amountLabel = amountLabel,
    provider = provider,
    providerConfig = providerConfig?.let {
        AdminPaymentMethodProviderConfig(
            provider = it.provider,
            enabled = it.enabled,
            publicKeyOrClientId = it.publicKeyOrClientId,
            secretMasked = it.secretMasked,
            paypalMode = it.paypalMode,
        )
    },
    systemDefault = systemDefault,
    usesForeignCurrency = usesForeignCurrency,
    foreignCurrencyCode = foreignCurrencyCode,
    createdAt = createdAt,
)

private fun AdminSettingsModulesDto.toModules() = AdminSettingsModules(
    accessEnabled = accessEnabled,
    exchangeRatesEnabled = exchangeRatesEnabled,
    suppressAccessWhileCapturing = suppressAccessWhileCapturing,
    clientAccountsEnabled = clientAccountsEnabled,
    schedulesAutomatic = schedulesAutomatic,
    membershipAccessGraceDays = membershipAccessGraceDays.coerceIn(0, 30),
    bulkPaymentsAlwaysPaid = bulkPaymentsAlwaysPaid,
    exchangePanelVisible = exchangePanelVisible,
)

private fun AdminProductLicenseStatusDto.toModel() = AdminProductLicenseStatus(
    status = status,
    installId = installId,
    issuedAt = issuedAt,
    expiresAt = expiresAt,
    indefinite = indefinite,
    graceDays = graceDays,
    daysRemaining = daysRemaining,
    graceDaysRemaining = graceDaysRemaining,
    features = features,
    edition = edition,
    message = message,
    canActivate = canActivate,
)

private fun AdminAccessTerminalDto.toTerminal() = AdminAccessTerminal(
    id = id,
    name = name,
    enabled = enabled,
    host = host,
    port = port,
    username = username,
    password = password,
    branchId = branchId,
    branchName = branchName,
    webhookSecret = webhookSecret,
    attendanceMode = AdminAccessAttendanceMode.fromApi(attendanceMode),
    webhookNotifyHost = webhookNotifyHost,
    webhookNotifyPort = webhookNotifyPort,
    lastSeenAt = lastSeenAt,
    lastError = lastError,
    createdAt = createdAt,
    lastReviewAt = lastReviewAt,
    pendingReview = pendingReview,
)

private fun AdminAccessTerminalUpsert.toDto() = UpsertAdminAccessTerminalRequestDto(
    name = name.trim(),
    enabled = enabled,
    host = host.trim(),
    port = port,
    username = username.trim(),
    password = password?.trim()?.ifBlank { null },
    branchId = branchId,
    webhookSecret = webhookSecret?.trim()?.ifBlank { null },
    attendanceMode = attendanceMode.name,
    webhookNotifyHost = webhookNotifyHost?.trim()?.ifBlank { null },
    webhookNotifyPort = webhookNotifyPort,
)

private fun AdminAccessEventDto.toEvent() = AdminAccessEvent(
    id = id,
    terminalId = terminalId,
    terminalName = terminalName.orEmpty(),
    clientId = clientId,
    clientName = clientName,
    staffId = staffId,
    bookingId = bookingId,
    eventTime = eventTime,
    authType = authType,
    success = success,
    result = result,
    resultLabel = resultLabel ?: result,
)

private fun AdminSettingsNotificationRuleDto.toRule() = AdminSettingsNotificationRule(
    id = id,
    eventCode = AdminNotificationEventCode.fromApi(eventCode),
    eventLabel = eventLabel ?: AdminNotificationEventCode.fromApi(eventCode).labelEs(),
    emailEnabled = emailEnabled,
    pushEnabled = pushEnabled,
    webEnabled = webEnabled,
    createdAt = createdAt,
)

private fun org.gymly.api.dto.AdminSettingsNotificationScheduleDto.toNotificationSchedule() =
    org.gymly.model.AdminSettingsNotificationSchedule(
        id = id,
        eventCode = AdminNotificationEventCode.fromApi(eventCode),
        eventLabel = eventLabel ?: AdminNotificationEventCode.fromApi(eventCode).labelEs(),
        enabled = enabled,
        frequency = org.gymly.model.AdminNotificationScheduleFrequency.fromApi(frequency),
        frequencyLabel = frequencyLabel
            ?: org.gymly.model.AdminNotificationScheduleFrequency.fromApi(frequency).labelEs(),
        sendHour = sendHour,
        mondayEnabled = mondayEnabled,
        tuesdayEnabled = tuesdayEnabled,
        wednesdayEnabled = wednesdayEnabled,
        thursdayEnabled = thursdayEnabled,
        fridayEnabled = fridayEnabled,
        saturdayEnabled = saturdayEnabled,
        sundayEnabled = sundayEnabled,
        leadDays = leadDays,
        timezone = timezone,
        inactivateAfterDays = inactivateAfterDays,
        updatedAt = updatedAt,
    )

private fun AdminSettingsNotificationTemplateDto.toTemplate() = AdminSettingsNotificationTemplate(
    id = id,
    eventCode = AdminNotificationEventCode.fromApi(eventCode),
    eventLabel = eventLabel,
    emailSubject = emailSubject,
    emailBodyText = emailBodyText,
    webTitle = webTitle,
    webBody = webBody,
)

private fun productPriceLabel(priceCents: Long, currency: String, priceUsdCents: Long): String {
    val bs = formatMoney(priceCents.toInt(), currency)
    return if (priceUsdCents > 0L) "$bs · ${formatMoney(priceUsdCents.toInt(), "USD")}" else bs
}

private fun AdminProductDto.toProduct(session: PortalSession) = AdminProduct(
    id = id,
    name = name,
    category = category,
    categoryLabel = categoryLabel ?: category,
    priceCents = priceCents,
    priceUsdCents = priceUsdCents,
    currency = currency,
    stockQty = stockQty,
    minStockQty = minStockQty,
    stockLevel = AdminProductStockLevel.fromApi(stockLevel),
    stockLevelLabel = stockLevelLabel ?: AdminProductStockLevel.fromApi(stockLevel).labelEs(),
    description = description,
    active = active,
    branchId = branchId,
    branchName = branchName,
    createdAt = createdAt,
    ingredients = ingredients,
    videoUrl = videoUrl,
    imageUrl = imageUrl?.let { resolveApiUrl(session, it) },
)

private fun AdminStoreSaleDto.toStoreSale(session: PortalSession): AdminStoreSale {
    val methodEnum = AdminStoreSaleMethod.fromApi(method)
    val originEnum = AdminStoreSaleOrigin.fromApi(origin)
    val statusEnum = AdminStoreSaleStatus.fromApi(status)
    return AdminStoreSale(
        id = id,
        saleNumber = saleNumber,
        clientId = clientId,
        customerName = customerName,
        branchId = branchId,
        branchName = branchName,
        method = methodEnum,
        methodLabel = methodLabel ?: methodEnum.labelEs(),
        origin = originEnum,
        originLabel = originLabel ?: originEnum.labelEs(),
        status = statusEnum,
        statusLabel = statusLabel ?: statusEnum.labelEs(),
        saleDate = saleDate,
        totalCents = totalCents,
        amountPaidCents = amountPaidCents?.takeIf { it > 0 } ?: totalCents,
        changeGivenCents = changeGivenCents,
        foreignUsdCents = foreignUsdCents?.takeIf { it > 0 },
        currency = currency,
        notes = notes,
        proofUrl = proofUrl?.let { resolveApiUrl(session, it) },
        proofContentType = proofContentType,
        itemsSummary = itemsSummary ?: items.joinToString(", ") { "${it.productName} x${it.qty}" }.ifBlank { "—" },
        items = items.map {
            AdminStoreSaleItem(
                id = it.id,
                productId = it.productId,
                productName = it.productName,
                qty = it.qty,
                unitPriceCents = it.unitPriceCents,
                lineTotalCents = it.lineTotalCents,
            )
        },
        createdAt = createdAt,
        pendingBsCents = pendingBsCents,
        pendingUsdCents = pendingUsdCents,
        payments = payments.map {
            AdminStorePaymentLine(
                method = AdminStoreSaleMethod.fromApi(it.method),
                currency = it.currency,
                amountCents = it.amountCents,
            )
        },
        discountCents = discountCents.coerceAtLeast(0L),
        discountReason = discountReason,
        discountNote = discountNote,
        discountUsdCents = discountUsdCents.coerceAtLeast(0L),
    )
}

private fun AdminMembershipOrderDto.toMembershipOrder(session: PortalSession): AdminMembershipOrder {
    val methodEnum = method?.let { AdminPaymentMethod.fromApi(it) }
    val originEnum = AdminMembershipOrderOrigin.fromApi(origin)
    val statusEnum = AdminMembershipOrderStatus.fromApi(status)
    val paymentRows = payments.map { p ->
        val pStatus = AdminPaymentStatus.fromApi(p.status)
        AdminMembershipOrderPayment(
            id = p.id,
            amountCents = p.amountCents,
            currency = p.currency,
            method = p.method.takeIf { it.isNotBlank() }?.let { AdminPaymentMethod.fromApi(it) },
            methodLabel = p.methodLabel ?: p.method.takeIf { it.isNotBlank() }?.let { AdminPaymentMethod.fromApi(it).labelEs() } ?: p.method,
            status = pStatus,
            statusLabel = p.statusLabel ?: pStatus.labelEs(),
            notes = p.notes,
            payerPhone = p.payerPhone,
            proofUrl = p.proofUrl?.let { resolveApiUrl(session, it) },
            proofContentType = p.proofContentType,
            paidAt = p.paidAt,
            createdAt = p.createdAt,
            foreignUsdCents = p.foreignUsdCents,
            collectionId = p.collectionId,
            changeGivenCents = p.changeGivenCents.coerceAtLeast(0L),
        )
    }
    return AdminMembershipOrder(
        id = id,
        orderNumber = orderNumber,
        clientId = clientId,
        clientName = clientName,
        planId = planId,
        planName = planName,
        branchId = branchId,
        branchName = branchName,
        trainerId = trainerId,
        trainerName = trainerName,
        method = methodEnum,
        methodLabel = methodLabel ?: methodEnum?.labelEs(),
        payerPhone = payerPhone,
        origin = originEnum,
        originLabel = originLabel ?: originEnum.labelEs(),
        status = statusEnum,
        statusLabel = statusLabel ?: statusEnum.labelEs(),
        orderDate = orderDate,
        planEndsAt = planEndsAt,
        amountCents = amountCents,
        paidCents = paidCents.coerceAtLeast(0L),
        allocatedCents = allocatedCents.coerceAtLeast(0L),
        planUsdCents = planUsdCents.coerceAtLeast(0L),
        paidUsdCents = paidUsdCents.coerceAtLeast(0L),
        pendingUsdCents = pendingUsdCents.coerceAtLeast(0L),
        pendingBsCents = pendingBsCents.coerceAtLeast(0L),
        salesOrderId = salesOrderId,
        currency = currency,
        notes = notes,
        proofUrl = proofUrl?.let { resolveApiUrl(session, it) },
        proofContentType = proofContentType,
        createdAt = createdAt,
        payments = paymentRows,
        changeGivenCents = changeGivenCents,
        discountCents = discountCents.coerceAtLeast(0L),
        discountReason = discountReason,
        discountNote = discountNote,
        discountUsdCents = discountUsdCents.coerceAtLeast(0L),
    )
}

private fun AdminBookingDto.toBooking() = AdminBookingItem(
    id = id,
    clientId = clientId,
    clientName = clientName,
    scheduleId = scheduleId,
    title = title,
    sessionDate = sessionDate,
    weekday = weekday,
    startTime = startTime,
    endTime = endTime,
    status = AdminBookingStatus.fromApi(status),
    notes = notes,
    createdAt = createdAt,
)

private fun normalizeTime(raw: String): String {
    val t = raw.trim().take(5)
    return if (t.length == 5) "$t:00" else raw.trim()
}

internal fun String.encodeURLQuery(): String = buildString {
    for (ch in this@encodeURLQuery) {
        when {
            ch.isLetterOrDigit() || ch in "-._~" -> append(ch)
            else -> append('%').append(ch.code.toString(16).uppercase().padStart(2, '0'))
        }
    }
}

@OptIn(ExperimentalEncodingApi::class)
private fun decodeCaptureFaceBase64(raw: String): ByteArray = Base64.decode(raw)

private fun org.gymly.api.dto.AdminExchangeRateQuoteDto.toExchangeQuote() = org.gymly.model.AdminExchangeRateQuote(
    effectiveDate = effectiveDate,
    eurRate = eurRate,
    usdRate = usdRate,
    cnyRate = cnyRate,
    tryRate = tryRate,
    rubRate = rubRate,
    source = source,
    status = runCatching { org.gymly.model.AdminExchangeRateStatus.valueOf(status) }
        .getOrDefault(org.gymly.model.AdminExchangeRateStatus.UNAVAILABLE),
    fetchedAt = fetchedAt,
    manualOverrideEnabled = manualOverrideEnabled,
    divisasUsesEurRate = divisasUsesEurRate,
)

private fun org.gymly.api.dto.AdminExchangeRateSettingsDto.toExchangeSettings() = org.gymly.model.AdminExchangeRateSettings(
    manualOverrideEnabled = manualOverrideEnabled,
    manualEurRate = manualEurRate,
    manualUsdRate = manualUsdRate,
    manualCnyRate = manualCnyRate,
    manualTryRate = manualTryRate,
    manualRubRate = manualRubRate,
    manualEffectiveDate = manualEffectiveDate,
    divisasUsesEurRate = divisasUsesEurRate,
    current = current.toExchangeQuote(),
    history = history.map {
        org.gymly.model.AdminExchangeRateHistory(
            effectiveDate = it.effectiveDate,
            eurRate = it.eurRate,
            usdRate = it.usdRate,
            source = it.source,
            status = it.status,
            fetchedAt = it.fetchedAt,
        )
    },
)

private fun org.gymly.api.dto.AdminDivisasConversionDto.toDivisasConversion() = org.gymly.model.AdminDivisasConversion(
    usdCents = usdCents,
    eurCents = eurCents,
    vesCents = vesCents,
    eurRate = eurRate,
    usdRate = usdRate,
    effectiveDate = effectiveDate,
)

private fun org.gymly.api.dto.AdminClientAccountSummaryDto.toClientAccountSummary() = org.gymly.model.AdminClientAccountSummary(
    clientId = clientId,
    clientName = clientName,
    clientEmail = clientEmail,
    balanceCents = balanceCents,
    pendingDebtCents = pendingDebtCents,
    currency = currency,
)

private fun org.gymly.api.dto.AdminClientAccountStatementDto.toClientAccountStatement() = org.gymly.model.AdminClientAccountStatement(
    clientId = clientId,
    clientName = clientName,
    balanceCents = balanceCents,
    pendingDebtCents = pendingDebtCents,
    currency = currency,
    entries = entries.map { it.toClientAccountEntry() },
)

private fun org.gymly.api.dto.AdminClientAccountEntryDto.toClientAccountEntry() = org.gymly.model.AdminClientAccountEntry(
    id = id,
    entryType = runCatching { org.gymly.model.AdminClientAccountEntryType.valueOf(entryType) }
        .getOrDefault(org.gymly.model.AdminClientAccountEntryType.ADJUSTMENT),
    amountCents = amountCents,
    balanceAfterCents = balanceAfterCents,
    description = description,
    membershipOrderId = membershipOrderId,
    membershipOrderNumber = membershipOrderNumber,
    salesOrderId = salesOrderId,
    salesOrderNumber = salesOrderNumber,
    paymentId = paymentId,
    effectiveAt = effectiveAt,
)

private fun org.gymly.api.dto.AdminClientAccountApplyCreditResultDto.toClientAccountApplyCreditResult() =
    org.gymly.model.AdminClientAccountApplyCreditResult(
        clientId = clientId,
        appliedCents = appliedCents,
        balanceAfterCents = balanceAfterCents,
        salesOrderId = salesOrderId,
        membershipOrderId = membershipOrderId,
    )
